var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmmc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-321d2cdd-0ff7-43e9-bd92-466c86224017",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 964.79 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M192.87,676.21c-1.07-.81-1.95-.11-2.84.38-14.22,7.93-28.43,15.88-42.65,23.8-13.98,7.79-27.97,15.55-41.95,23.33-11.19,6.23-22.35,12.49-33.54,18.7-.95.53-1.78,1.39-3.39,1.42.49-4.34.91-8.59,1.46-12.83,2.18-16.94,4.39-33.87,6.62-50.8.83-6.33,1.7-12.66,2.63-18.97.59-4.02.53-4.28-3.11-5.95-25.15-11.53-50.3-23.05-75.44-34.58-.24-.11-.45-.32-.66-.48-.09-.82.58-.88,1.03-1.13,26.04-13.78,52.08-27.56,78.13-41.33,11.06-5.85,22.14-11.68,33.2-17.53.91-.48,1.75-1.09,2.62-1.64.51-1.27,1.75-1.64,2.79-2.26,2.83-1.68,2.99-1.93,1.74-4.91-3.2-7.65-6.11-15.41-8.84-23.24-4.38-12.55-8.02-25.32-11.08-38.25-3.47-14.6-5.98-29.36-7.73-44.24-1.06-8.96-1.66-17.98-2.05-27.01-.34-7.91-.57-15.81-.46-23.71.38-27.77,3.51-55.21,9.66-82.31,5.32-23.41,12.74-46.12,22.19-68.17,8.3-19.35,18.24-37.82,29.53-55.6,9.97-15.7,21.05-30.58,33.14-44.68,10.68-12.45,22.25-24.05,34.32-35.16,14.73-13.56,30.48-25.82,47.17-36.84,35.28-23.28,73.3-40.51,114.12-51.56,19.32-5.23,38.92-8.97,58.81-11.12,9.16-.99,18.35-1.7,27.58-2.01,7.24-.24,14.49-.49,21.73-.38,16.1.25,32.14,1.44,48.1,3.61,26.61,3.62,52.56,9.96,77.84,18.97,20.27,7.22,39.81,16.04,58.66,26.47,23.01,12.74,44.44,27.71,64.46,44.69,13.15,11.15,25.52,23.12,37.01,36.02,13.2,14.79,25.36,30.36,36.27,46.9,16.83,25.51,30.52,52.61,41.02,81.32,9.52,26.03,16.15,52.78,19.99,80.2,1.58,11.27,2.51,22.62,3.18,34,.73,12.25.79,24.51.29,36.71-.84,20.61-3.2,41.08-7.34,61.35-5.1,24.91-12.31,49.15-22.01,72.65-1.17,2.82-.9,3.5,1.77,4.97,1.06.59,2.28.93,3.08,1.95.17,1.13,1.16,1.44,1.96,1.87,15.55,8.23,31.12,16.43,46.68,24.66,13.97,7.39,27.93,14.81,41.89,22.21,7.89,4.18,15.79,8.33,24.31,12.81-3.42,1.62-6.31,3.01-9.23,4.35-14.46,6.62-28.92,13.23-43.39,19.83-8.13,3.71-16.26,7.44-24.42,11.08-2.16.96-3.21,1.82-2.81,4.74,2.75,19.89,5.14,39.83,7.69,59.75,1.03,8.07,2.16,16.13,3.3,24.58-8.62-4.79-16.92-9.39-25.21-14-15.87-8.83-31.74-17.66-47.6-26.51-15.78-8.8-31.54-17.62-47.33-26.4-1.07-.6-2.08-1.82-3.56-.87-1.66-.49-2.92-1.69-4.45-2.43-1.38-.67-2.34-.55-3.48.61-26.36,26.97-55.79,49.99-88.61,68.61-28.9,16.4-59.4,28.93-91.51,37.55-20.23,5.43-40.75,9.29-61.61,11.32-8.15.79-16.29,1.37-24.48,1.75-5.93.27-11.85.41-17.77.41-14.6,0-29.12-1.06-43.63-2.65-17.55-1.92-34.86-5.1-51.93-9.49-24.14-6.21-47.5-14.58-70.07-25.24-32.06-15.14-61.49-34.26-88.42-57.28-5.43-4.64-10.87-9.32-15.81-14.51-2.98-3.14-6.65-5.56-9.21-9.13-1.12-1.56-2.52-1.65-4.2-.71-1.4.77-2.69,1.74-4.19,2.32h0Z",
    style: {
      fill: "#72bdf1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.94,556.98c-.37-.05-.77-.02-1.11-.15-6.06-2.3-6.16-2.73-3.76-8.67,9.78-24.12,17.13-48.96,21.99-74.54,2.78-14.6,4.51-29.31,5.76-44.11,1.28-15.24,1.45-30.49.84-45.72-1.01-25.01-4.35-49.76-10.14-74.15-7.63-32.11-19.04-62.81-34.42-92-12.68-24.05-27.66-46.58-45.05-67.51-8.73-10.51-17.82-20.69-27.62-30.19-25.26-24.49-53.11-45.51-83.88-62.66-24.2-13.48-49.53-24.22-75.97-32.35-19.52-6-39.4-10.44-59.66-13.15-13.33-1.78-26.68-3.03-40.13-3.52-8.48-.32-16.95-.52-25.4-.24-15.96.53-31.87,1.87-47.69,4.23-25,3.73-49.4,9.81-73.2,18.28-23.92,8.52-46.77,19.32-68.61,32.29-19.48,11.56-37.8,24.71-54.96,39.46-14.15,12.16-27.34,25.33-39.67,39.35-12.02,13.66-23.02,28.08-33,43.28-17.34,26.4-31.29,54.48-41.84,84.27-8.06,22.75-13.89,46.06-17.66,69.88-1.73,10.95-2.9,21.96-3.63,33.04-.84,12.69-1.33,25.39-.9,38.08.54,16.24,1.79,32.43,4.24,48.53,3.33,21.9,8.42,43.34,15.27,64.38,3.27,10.02,7,19.88,11.16,29.57.75,1.74.71,2.66-1.15,3.43-1.65.68-3.16,1.67-4.73,2.52-6.89-15.29-12.36-31.1-17.06-47.18-5.2-17.8-9.12-35.89-11.67-54.25-1.84-13.23-3.12-26.51-3.72-39.87-.98-21.87-.12-43.66,2.51-65.37,5.24-43.3,17.2-84.65,35.98-124.04,16.45-34.5,37.43-65.98,62.87-94.44,26.35-29.47,56.43-54.54,90.22-75.12,35.06-21.35,72.49-36.98,112.37-46.75,17.92-4.39,36.05-7.48,54.4-9.4,16.32-1.71,32.68-2.44,49.06-2.08,38.68.85,76.52,6.96,113.41,18.74,40.86,13.06,78.64,32.21,113.36,57.4,25.05,18.17,47.69,38.98,67.9,62.38,25.71,29.77,46.61,62.64,62.64,98.59,13.48,30.21,23.03,61.61,28.66,94.19,2.93,16.97,4.75,34.06,5.47,51.29.72,17.25.44,34.47-1.02,51.65-2.54,29.89-8.39,59.15-17.52,87.74-3.78,11.84-8.24,23.41-12.94,34.9h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,676.21c1.22-2.57,4.07-2.81,6.12-4.16.86-.57,1.56.8,2.17,1.44,7.35,7.7,15.13,14.92,23.11,21.95,15.71,13.84,32.49,26.24,50.23,37.34,19.44,12.16,39.77,22.6,61.06,31.11,25.05,10.01,50.81,17.53,77.42,22.15,17.8,3.09,35.7,5.02,53.76,5.75,8.86.36,17.71.54,26.54.25,25.6-.84,50.94-3.88,75.92-9.63,27.97-6.44,54.93-15.76,80.87-28.09,28.19-13.41,54.35-29.96,78.61-49.59,11.8-9.55,22.94-19.79,33.67-30.5,2.53-2.52,5.32-2.76,8.37-.72.62.41,1.36.71,1.48,1.59-30.05,31.7-64.32,57.86-102.91,78.35-37.34,19.82-76.8,33.41-118.48,40.59-18.75,3.23-37.61,5-56.63,5.72-18.67.71-37.26-.11-55.78-2.09-27.07-2.88-53.61-8.54-79.52-16.99-50.85-16.56-96.57-42.24-137.16-77.06-10.08-8.65-19.76-17.73-28.86-27.41h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.28,533.17c0-8.39-.11-16.77.06-25.15.05-2.58-.77-3.1-3.2-3.09-24.69.08-49.38.06-74.07.05-3.19,0-3.23-.02-2.17-2.99,6.97-19.35,11.92-39.21,14.79-59.55,1.27-9.01,2.13-18.09,2.56-27.21.38-8.01.56-16,.31-23.99-1.01-31.99-6.83-63.09-17.7-93.23-7.71-21.34-17.73-41.53-30.07-60.57-9.9-15.27-21.09-29.53-33.56-42.8-22.84-24.29-49-44.15-78.43-59.79-26.64-14.15-54.79-23.89-84.38-29.49-11.07-2.09-22.24-3.59-33.52-4.28-9.49-.57-18.97-1.22-28.48-.88-16.26.57-32.43,2.06-48.44,5.08-20.21,3.82-39.85,9.55-58.88,17.37-22.66,9.32-43.81,21.31-63.57,35.78-12.1,8.86-23.49,18.57-34.06,29.17-20.78,20.86-38.33,44.17-52.3,70.14-11.98,22.25-21.01,45.61-27.07,70.12-3.43,13.88-5.82,27.93-7.21,42.17-1.2,12.37-1.88,24.77-1.52,37.19.48,16.46,2.14,32.8,5.23,48.99,3.03,15.92,7.27,31.51,12.89,46.71.53,1.44.42,2.08-1.3,2.07-6.12-.04-12.25-.1-18.37.03-1.92.04-2.01-1.28-2.52-2.42-4.11-9.24-15.45-11.34-22.09-4.12-1.11,1.2-2.02,2.6-2.4,4.11-.54,2.14-1.81,2.44-3.72,2.41-7.54-.08-15.08.07-22.62-.09-2.44-.05-2.96.77-2.94,3.05.11,11.77.05,23.55-.26,35.36-26.95-68.12-34.52-138.3-21.8-210.54,12.76-72.47,43.78-136.26,93.11-190.71C331.96-8.46,546.8-21.71,695.71,79.17c172.44,116.82,200.66,317.35,147.57,454h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76,662.09H135.08c-2.79,0-4.19-1.36-4.19-4.09,0-47.59.02-95.18-.06-142.77,0-2.77.53-3.8,3.53-3.65,5.45.27,10.93.14,16.39.04,1.8-.03,2.9.42,3.77,2.14,2.41,4.74,6.61,6.97,11.76,6.87,5.05-.1,9-2.55,11.38-7.11.7-1.35,1.48-2.09,3.03-1.87.55.08,1.13.01,1.7.01,216.65,0,433.31,0,649.96,0,4.76,0,4.24-.53,4.24,4.21.01,47.49,0,94.99,0,142.48,0,2.49-1.19,3.74-3.57,3.74-40.99,0-81.99-.01-122.98.04-2.15,0-3.47-.45-4.74-2.46-5.06-7.98-16.8-7.99-21.79.03-1.31,2.09-2.67,2.41-4.77,2.41-90.66-.03-181.31-.03-271.97-.03h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.18,681.92c4.87-.87,9.25-3.13,13.75-4.99,5.82-2.4,11.53-5.11,17.25-7.74,1.24-.57,2.47-.81,3.81-.81,20.17.02,40.33.03,60.49-.02,1.84,0,2.76.37,3.34,2.4,1.59,5.57,6.84,9.38,12.39,9.44,5.85.07,10.9-3.47,12.74-9.29.62-1.96,1.48-2.58,3.53-2.57,15.17.09,30.34.05,45.51.05h1.91l.31.87c-71.35,71.23-157.16,111.45-258.24,115.81-114.74,4.95-212.56-35.16-294.3-115.73,1.36-1.29,2.35-.94,3.23-.94,45.61-.02,91.21,0,136.82-.06,2.5,0,4.57.99,6.67,2,5.76,2.78,11.52,5.56,17.59,7.63.9-.09,1.52.4,2.07,1.02,2.96,3.66,6.37,6.91,9.85,10.03,2.59,2.32,5.06,4.74,7.57,7.14.97,1.03,1.97,2.02,2.99,3,3.41,3.33,6.96,6.5,10.63,9.53,2.9,2.77,5.91,5.41,9.04,7.91,2.49,2.44,5.28,4.55,7.96,6.77,2.23,1.93,4.49,3.84,6.82,5.66,3.18,2.44,6.28,4.99,9.52,7.34,2.09,1.91,4.46,3.45,6.77,5.07,1.51,1.19,3.03,2.35,4.6,3.45,2.95,2.1,5.88,4.23,8.92,6.2,3.54,2.47,7.16,4.83,10.76,7.21,1.88,1.12,3.7,2.35,5.59,3.46,1.64,1.03,3.29,2.04,5.04,2.87,3.49,2.28,3.56,2.27,6.77-.6,1.7-1.36,3.6-2.47,5.23-3.92,2.65-2.04,5.31-4.07,7.89-6.19,1.92-1.48,3.79-3.03,5.68-4.54,2.15-1.58,4.08-3.44,6.19-5.07,1.66-1.57,3.63-2.76,5.12-4.51,1.3-1.05,2.51-2.23,4.12-2.81,3.64-1.16,6.01-4.11,8.9-6.31,5.81-4.92,11.84-9.57,17.64-14.52,6.29-5.38,12.54-10.82,18.45-16.59,5.86-5.71,12.25-10.87,17.59-17.11.36-.42.79-.83,1.45-.55h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.98,504.94c-1.03.02-2.07.07-3.1.07h-194.51c-1.22,0-2.45-.06-3.67-.1-.75-.61-1.27-1.35-1.62-2.25-3.4-8.73-6.27-17.64-9.36-26.47-1.63-6.5-3.64-12.88-5.58-19.29-.39-3.16-1.41-6.18-2.14-9.26-2.35-10.32-4.56-20.65-6.25-31.1-.77-6.58-1.97-13.09-2.71-19.67-.19-1.67-.37-3.34-.32-5.02.36-4.9-.61-9.73-.82-14.6-.22-5.16-1.01-10.29-.78-15.47.14-3.1,1.03-3.65,3.89-2.15,4.67,2.44,9.17,5.19,13.76,7.78,10.48,5.92,21.03,11.75,31.49,17.72,12.1,6.89,24.18,13.83,36.33,20.61,15.69,8.75,31.26,17.72,46.96,26.47,10.76,6,21.5,12.06,32.17,18.22,6.93,4,13.89,7.93,20.89,11.8,1.3.72,2.97,1.33,1.61,3.36-2.95,2.39-5.66,4.91-6.85,8.74-2.02,6.5,1.45,13.7,7.92,16.07,6.59,2.42,14.1-.85,16.65-7.27.38-.96.55-2,1.07-2.91,1.43-4.54,1.43-4.52,5.96-2.28,2.7,1.32,5.36,2.7,7.88,4.34,3.08,3,6.91,4.72,10.84,6.3.15.13.35.24.39.4,1.2,5.33,1.39,10.65-.08,15.96h0Z",
    style: {
      fill: "#224175",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.82,504.88c-1.13.04-2.26.11-3.38.11h-93.12c-1.13,0-2.26-.05-3.38-.08.49-3,3.1-4.34,5.04-6.08,7.68-6.93,15.58-13.63,23.04-20.79,10.93-10.48,22.47-20.28,33.6-30.53,9.48-8.73,19.22-17.17,28.57-26.04,8.66-8.21,17.58-16.17,26.57-24.04,4.32-3.77,8.47-7.74,12.81-11.49,2.02-1.75,2.52-1.59,3.41.94-.25,8.36-1.91,16.54-3.13,24.76-.19,1.3-.49,2.57-.75,3.86-2.54,12.73-5.54,25.35-9.29,37.79-2.08,6.9-4.39,13.74-6.82,20.52-3.37,9.4-7.13,18.64-11.12,27.78-.51,1.17-.77,2.56-2.05,3.27h.01Z",
    style: {
      fill: "#405382",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.27,386.25c-.25-1.5-.93-1.06-1.69-.38-5.37,4.81-10.78,9.59-16.12,14.44-10.62,9.64-21.21,19.31-31.8,28.98-6.65,6.07-13.24,12.19-19.94,18.2-8.15,7.32-16.43,14.51-24.58,21.83-3.68,3.31-7.16,6.84-10.81,10.18-8.49,7.79-17.04,15.53-25.56,23.31-.68.63-1.24,1.4-1.85,2.1h-27.14c-.33-1.02.37-1.62.98-2.15,6.25-5.43,12.23-11.15,18.45-16.62,6.5-5.72,12.88-11.56,19.34-17.3,10.54-9.37,20.64-19.24,31.23-28.56,8.54-7.52,16.9-15.25,25.35-22.86,10.13-9.12,20.12-18.41,30.22-27.58,10.17-9.23,20.54-18.24,30.59-27.59,1.22-1.13,2.6-3.05,4.15-2.45,1.78.68.85,3.01.92,4.61.14,3.01-.04,6.02.15,9.04.28,3.58-.23,7.11-.59,10.64-.09.88-.04,1.96-1.31,2.17h0Z",
    style: {
      fill: "#445a89",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,668.8c1.01-.77,2.18-.42,3.28-.42,56.68,0,113.35.01,170.03.04,1.1,0,2.27-.31,3.27.48-.51,2.58-3,3.55-4.37,5.43-3.43,3.34-6.77,6.76-10.16,10.15-1.04.96-1.97,2.04-3.1,2.9-3.16,2.25-5.43,5.43-8.41,7.87-2.55,1.74-4.43,4.18-6.66,6.27-2.31,1.65-4.22,3.74-6.34,5.6-1.99,1.19-3.3,3.15-5.12,4.55-2.21,1.49-3.87,3.65-6.07,5.15-2.18,1.79-4.31,3.64-6.35,5.58-2.12,1.62-4.16,3.33-6.14,5.13-2.17,1.6-4.24,3.33-6.31,5.06-2.18,1.62-4.18,3.45-6.3,5.16-2.23,1.36-3.78,3.7-6.44,4.44-.55-.11-.82-.5-1.02-.98-.48-1.57-.33-3.18-.33-4.78-.01-20.73,0-41.46-.01-62.19,0-4.38-.02-4.39-4.39-4.39h-84.52c-.94,0-1.88.02-2.83-.05-.8.07-1.45-.13-1.72-.98h0Z",
    style: {
      fill: "#405383",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.4,372.68v-12.69c-1.49.57-2.54,1.4-3.53,2.3-8.4,7.63-16.71,15.38-25.22,22.89-8.79,7.76-17.34,15.8-25.98,23.73-9.81,9.01-19.71,17.93-29.63,26.81-8.39,7.51-16.81,14.97-25.03,22.68-10.39,9.75-21.24,19.02-31.81,28.58-6.54,5.9-12.94,11.96-19.41,17.94-2.11.44-3.05-.16-2.95-2.57.2-4.78.1-9.58.13-14.37,9.17-8.38,18.14-16.98,27.43-25.22,11.83-10.48,23.51-21.13,35.37-31.6,6.21-5.48,11.95-11.47,18.17-16.94,8.69-7.65,17.19-15.51,25.84-23.2,7.53-6.69,15.24-13.2,22.45-20.21,8.85-8.6,18.18-16.63,27.31-24.91,1.19-1.07,2.26-2.27,3.47-3.32.85-.74,1.79-1.65,2.99-1.21,1.35.49,1,1.87,1.05,2.96.09,1.96-.25,3.98.88,5.78.45,1.17.5,2.4.4,3.61-.48,5.41-.55,10.83-.57,16.25,0,1.04.15,2.34-1.35,2.72h-.01Z",
    style: {
      fill: "#475f8f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.96,349.43c-1.2-1.81-.32-3.83-.59-5.75-.09-.62.28-1.45-.41-1.8-.77-.4-1.46.21-1.99.7-2.14,1.97-4.25,3.97-6.44,5.88-7.41,6.47-14.92,12.88-21.91,19.79-3.66,3.62-7.48,7.06-11.29,10.5-9.05,8.16-18.28,16.13-27.17,24.46-7.67,7.18-15.72,13.91-23.22,21.29-6.61,6.5-13.78,12.43-20.69,18.62-4.05,3.63-8.09,7.28-12.12,10.93-10.01,9.07-20.02,18.12-30.01,27.21-1.67,1.52-3.22,3.17-4.81,4.78-.94.96-1.95,1.78-3.34,1.93v-16.97c10.19-9.08,20.17-18.38,30.31-27.51,12.94-11.64,25.7-23.49,38.75-35.01,9.17-8.1,18.04-16.54,27.14-24.72,11.13-10.01,22.15-20.14,33.31-30.11,7.3-6.52,14.53-13.13,21.71-19.78,2.96-2.74,5.85-5.6,9.09-8.04,1.43-1.08,2.55-1.19,3.25.76,1.19,6.89,1.44,13.82,1.22,20.78-.02.76-.18,1.5-.78,2.05h0Z",
    style: {
      fill: "#4a6393",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.74,325.69c-2.29-.24-3.38,1.71-4.69,2.89-9.42,8.46-18.61,17.18-28.05,25.62-10.2,9.12-20.31,18.34-30.44,27.55-8.12,7.38-16.18,14.82-24.35,22.15-9.63,8.64-19.32,17.22-28.82,26.01-8.61,7.96-17.48,15.63-25.99,23.71-5.71,5.42-11.67,10.58-17.5,15.87-.86.78-1.76,1.4-2.94,1.53-.02-.75-.02-1.5-.07-2.25-.25-3.77-.33-6.63,4.77-8.1,5.25-1.5,7.71-6.5,7.74-12.2,0-1.13-.05-2.25-.07-3.37-.32-1.01.36-1.61.98-2.14,9.14-7.71,17.66-16.12,26.57-24.07,6.6-5.89,13.17-11.82,19.71-17.77,9.26-8.42,18.55-16.81,27.81-25.23,6.97-6.33,13.91-12.68,20.9-18.99,7.13-6.44,14.29-12.82,21.38-19.3,5.07-4.64,10.09-9.33,15.24-13.88,4.44-3.93,8.55-8.22,13.13-12.01.66-.54,1.27-1.15,2.23-1,.28.1.49.28.64.54.38.95.44,2,.93,2.92.94,3.11,1.09,6.36,1.56,9.54.11.74,0,1.48-.68,2v-.02Z",
    style: {
      fill: "#4d6897",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.33,490.23l-.21-5.01c-.87-1.05-.66-2.32-.66-3.52-.02-14.79,0-29.59-.03-44.39,0-2.41.5-4.37,2.65-5.84,8.99-6.12,15.31-14.39,19.36-24.44.14-.35.33-.68.53-1,.88-1.01,1.58-2.17,1.74-3.49.37-3.12,2.12-5.19,4.47-7.17,9.64-8.13,18.66-16.95,28.19-25.21,13.87-12.02,26.96-24.88,40.75-37,9.75-8.57,19.52-17.15,28.81-26.2,3.31-3.23,6.4-4.09,10.37-3.42,4.22.71,8.45.35,12.67.57.42.06.81.2,1.14.48.39.96-.41,1.37-.93,1.83-8.37,7.15-16.31,14.78-24.65,21.96-3.92,3.37-7.5,7.1-11.31,10.59-8.8,8.08-17.75,15.99-26.63,23.98-6.64,5.97-13.24,12-19.88,17.99-10.05,9.08-19.91,18.37-30.02,27.38-6.74,6.01-13.43,12.07-20.09,18.17-4.23,3.87-8.49,7.72-12.88,11.42-1.53,1.3-2.34,2.53-2.21,4.51.11,1.78.01,3.58.11,5.37.07,1.24-.02,2.49.08,3.73.08,2.58-.06,5.15.03,7.72,0,5.57.11,11.14-.06,16.71-.12,4.63.57,9.29-.42,13.89-.19.37-.49.49-.89.37v.02Z",
    style: {
      fill: "#5576a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,698.37c-4.91,3.13-9.99,5.97-15.24,8.49-2.96.59-3.64-1.96-4.59-3.68-2.65-4.77-5.55-9.4-8.31-14.1-8.1-13.79-16.22-27.57-24.4-41.32-9.95-16.73-19.82-33.52-29.73-50.27-.8-1.36-2.27-2.8-.44-4.48,4.8-2.8,9.63-5.54,14.74-7.72,2.31,2.97,4.13,6.26,6.02,9.49,9.17,15.67,18.54,31.22,27.77,46.86,10.37,17.58,20.74,35.16,31.1,52.75.87,1.48,1.92,2.77,3.09,3.98h0Z",
    style: {
      fill: "#38397a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.53,593.01c-.76,1.28-.06,2.35.55,3.4,8.19,13.8,16.42,27.59,24.58,41.41,6.72,11.4,13.32,22.87,20.06,34.26,5.25,8.89,10.64,17.7,15.94,26.56,1.16,1.93,2.21,3.92,3.36,5.86.68,1.15,1.49,2.19,2.98,2.35-4.48,3.07-9.37,5.39-14.15,7.91-1.78,1.27-2.66.21-3.53-1.24-3.57-5.97-7.02-12.01-10.63-17.96-5.21-8.6-10.14-17.37-15.55-25.86-.67-1.05-.86-2.04-.44-3.17-.08-3,.48-5.94,1.03-8.86.42-2.21.01-3.6-2.32-4.53-3.62-1.44-7.09-3.28-10.62-4.95-8.52-14.64-17.36-29.1-25.81-43.78-1.4-2.43-1.3-2.62,1.56-4.55,4.23-2.47,8.48-4.9,12.98-6.85h0Z",
    style: {
      fill: "#3e3c7f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.57,310.96c-2.45.75-3.94,2.84-5.7,4.41-8.12,7.26-15.94,14.83-24.01,22.15-10.35,9.38-20.86,18.58-31.24,27.93-5.44,4.9-10.69,10-16.12,14.92-9.23,8.38-18.54,16.68-27.81,25.03-4.39,3.96-8.68,8.02-13.11,11.93-9.64,8.49-18.75,17.58-28.59,25.85-.63.53-1.11,1.26-1.66,1.9-.9-2.49-2.53-4.55-3.94-6.74-1.78-1.23-1.24-2.39.03-3.65,4.83-4.76,10.05-9.09,15.05-13.66,6.53-5.97,13.09-11.9,19.73-17.75,5.08-4.48,10.13-9.01,15.1-13.6,3.94-3.63,7.72-7.43,11.73-10.99,6.89-6.12,13.79-12.25,20.6-18.47,6.47-5.9,12.96-11.77,19.49-17.6,10.25-9.14,20.06-18.79,30.44-27.8,3.4-2.96,6.98-5.79,9.95-9.2,2.53-2.91,5.59-3.04,8.94-2.63,1.41,2.51,2.44,5.07,1.11,7.96v.02Z",
    style: {
      fill: "#4f6b9b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.88,714.16c-4.5-2.19-8.86-4.62-13.07-7.33,1.28-1.12,2.3-2.44,3.16-3.92,7.18-12.37,14.48-24.68,21.81-36.97,6.98-11.72,13.86-23.51,20.91-35.2,6.57-10.87,13-21.83,19.43-32.79.97-1.65,1.67-3.35,1.53-5.3,3.89,1.31,7.24,3.63,10.74,5.66,4.34,2.44,4.2,2.36,1.68,6.61-7.46,12.62-14.99,25.21-22.33,37.9-1.06,1.84-2.21,3.39-4.21,4.18-4.14,2.03-8.28,4.05-12.42,6.08-.17,3.23.47,6.4,1.01,9.53.54,3.18.37,5.85-1.37,8.74-8.13,13.52-16.07,27.15-24.3,40.62-.59.97-.93,2.36-2.55,2.18v.02Z",
    style: {
      fill: "#3e3c80",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.79,702.34c-3.91-1.78-7.66-3.86-11.24-6.23,4.76-6.42,8.46-13.48,12.5-20.34.76-1.29,1.39-2.66,2.25-3.9,1.15-1.65.75-2.25-1.24-2.22-6.19.09-12.38-.06-18.58.1-5.63.07-11.25.11-16.88,0-8.67-.04-17.34.42-26-.28-.5-.16-1.38-.38-.51-.93.62-.39,1.65-.16,2.49-.16,21.74,0,43.48-.05,65.23.11,2.99.02,3.52-.89,3.51-3.64-.12-22.21-.08-44.42-.08-66.63,0-1.13.07-2.26.1-3.38.4-.14.7-.03.9.34.46.85.5,1.79.5,2.73-.02,8.5.13,17.01-.07,25.49-.12,11.07-.04,22.14-.06,33.78,1.91-2.39,3.05-4.52,4.27-6.62,8.12-13.88,16.42-27.65,24.6-41.5,4.21-7.13,8.27-14.34,12.72-21.33,1.4-2.2.72-3.96.08-5.95,3.77,1.53,7.26,3.6,10.74,5.67,3.99,2.54,3.96,2.53,1.41,6.87-9.73,16.56-19.47,33.13-29.29,49.63-10.64,17.89-21.08,35.9-31.9,53.68-.74,1.21-1.43,2.44-2.04,3.71-.79,1.62-1.89,1.95-3.4,1.01h0Z",
    style: {
      fill: "#383979",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,698.37c-1.54.19-2.15-.98-2.76-2.01-8.34-14.14-16.6-28.32-24.96-42.44-6.64-11.21-13.39-22.37-20.06-33.56-6.24-10.47-12.44-20.97-18.62-31.48-.66-1.12-1.06-2.39-1.57-3.59,3.83-2.34,7.7-4.6,11.85-6.35,3.91,6.19,7.66,12.48,11.32,18.83,4.78,8.31,9.83,16.46,14.66,24.74,3.59,6.16,7.14,12.35,11.21,18.69-.06-6.19.06-12.01-.1-17.83-.17-8.39-.1-16.77-.05-25.15-.1-11.8-.02-23.6-.05-35.41,0-1.22-.09-2.44.29-3.62.52-.49,1.03-.61,1.14.27.11.83.05,1.69.05,2.54-.01,34.36.01,68.71-.09,103.07,0,2.67.58,3.47,3.37,3.46,21.46-.14,42.92-.1,64.38-.11.75,0,1.62-.21,2.23.09,1.24.6.27.83-.32,1.04-9.58.59-19.17.23-28.75.23-4.85.08-9.7.11-14.55-.01-2.71-.12-5.45-.13-8.17-.07-2.31.06-2.57.48-1.32,2.47,4.14,6.6,7.73,13.53,12.11,19.99-3.6,2.35-7.33,4.46-11.25,6.25h0Z",
    style: {
      fill: "#323573",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.87,303.06c-.34.15-.72.47-1.03.41-4.21-.74-6.35,2.34-8.93,4.69-9.14,8.34-18.44,16.53-27.48,24.98-4.99,4.67-10.09,9.2-15.17,13.75-9.36,8.38-18.79,16.69-27.99,25.24-6.03,5.61-12.28,10.97-18.15,16.78-6.19,6.12-12.97,11.64-19.48,17.43-3.85,3.43-7.69,6.87-11.51,10.34-6.73,6.12-13.41,12.31-20.17,18.4-1.16,1.05-1.54,1.96-.55,3.25-2.32-1.44-4.54-3.09-7.32-3.58-1.71-1.08-.61-2.08.15-2.99,1.94-2.32,4.45-4.04,6.66-6.08,13.45-12.44,27.05-24.71,40.67-36.97,9.91-8.92,19.89-17.79,29.58-26.99,8.51-8.09,17.38-15.8,26.16-23.61,6.46-5.75,12.81-11.61,19.26-17.38,6.02-5.39,11.99-10.81,17.72-16.51,3.46-.43,6.98-.34,10.36-1.33,2.27-.83,4.62-.82,6.99-.64.32.19.41.46.25.8h0Z",
    style: {
      fill: "#506e9e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.28,581.78c3.13,1.84,1.88,4.06.54,6.29-9.18,15.37-18.39,30.72-27.55,46.1-4.51,7.57-8.93,15.2-13.4,22.79-.36.61-.53,1.68-1.45,1.43-.93-.25-.53-1.28-.54-1.97-.02-10.73-.02-21.46-.02-32.18,5.89-10.63,12.35-20.92,18.41-31.45,2.96-5.14,6.27-10.08,9.03-15.34.49-.94,1.15-1.71,1.96-2.38,4.65,1.62,8.75,4.33,13.01,6.71h0Z",
    style: {
      fill: "#323573",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.79,702.34c1.28.23,2.09.01,2.88-1.34,9.42-16.12,18.97-32.18,28.46-48.27,6.72-11.4,13.37-22.84,20.09-34.24,4.76-8.09,9.59-16.14,14.36-24.22,2.32-3.92,2.3-3.93-.56-6.83,3.55,1.09,6.35,3.59,9.62,5.2,1.14,1.1.97,2.2.2,3.49-5.3,8.96-10.53,17.97-15.81,26.94-7.37,12.53-14.73,25.07-22.15,37.57-7.18,12.1-14.42,24.16-21.63,36.24-1.63,2.74-3.29,5.47-4.81,8.27-.62,1.13-1.35,1.76-2.64,1.66-2.79-1.28-5.54-2.64-8.01-4.49h-.01Z",
    style: {
      fill: "#3a3a7c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.97,438.21c-.89,5.99-3.22,11.59-4.73,17.42-.3,1.16-.62,2.33-.93,3.49-1.39.52-1.61-.54-1.83-1.44-.32-1.29-.21-2.62-.21-3.94v-94.09c0-24.2-.01-48.41.02-72.61,0-1.66-.32-3.43.92-4.87,2.27-.33,4.46-1.61,6.85-.62-.56,2.04-.26,4.11-.26,6.16-.02,48.2-.03,96.4,0,144.61,0,1.96-.46,3.94.17,5.88h0Z",
    style: {
      fill: "#9c99a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.2,282.18c0,57.87,0,115.74.04,173.61,0,1.13-.88,2.75,1.07,3.33-1.67,6.98-4.37,13.62-6.75,20.36-1.62-.24-1.63-1.62-1.88-2.75-.28-1.29-.18-2.62-.18-3.94.06-18.52-.13-37.04.11-55.55,0-.57.02-1.13-.27-1.63,1.2-8.12,2.43-16.22,3.59-24.34.24-1.66.24-3.35.34-5.02.99-4.47,1.19-9.01,1.13-13.57.5-.52.48-1.18.5-1.83.18-6.05.37-12.09.54-18.14.03-1.12.08-2.25-.49-3.27.21-7.95-.27-15.86-1.22-23.74-.24-4-.85-7.95-1.63-11.88-.66-.86.11-1.99-.55-2.84h.01c-.08-2.74-.32-5.45-1.69-7.91-.01-.18-.03-.35-.04-.53-1.31-2.73-1.3-16.56.01-19.23,2.45-.37,4.9-.75,7.35-1.12h0Z",
    style: {
      fill: "#9f9ca4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.76,304.76c-1.82,3.62-5.11,5.94-7.93,8.62-4.61,4.39-9.51,8.48-14.26,12.72-8.88,7.93-17.76,15.85-26.61,23.83-4.95,4.46-9.87,8.96-14.7,13.54-9.79,9.3-19.93,18.22-30.01,27.2-6.09,5.43-12.03,11.02-18.17,16.39-8.45,7.4-16.22,15.53-24.83,22.77-1.39,1.16-4.17,2-3.17,4.93-2.87.08-5.8-.27-8.48,1.18-.48.37-1.02.35-1.57.2-.67-1.54.68-2.18,1.45-2.98,4.39-4.54,9.34-8.47,13.97-12.74,7.96-7.33,16.15-14.4,24.09-21.76,12.9-11.97,26.01-23.7,39.09-35.46,9.79-8.81,19.6-17.61,29.18-26.65,8.48-8,17.25-15.7,25.99-23.44,2.46-2.18,4.93-4.38,7.33-6.62.97-.9,1.94-1.79,3.23-2.24.29-.1.58-.16.88-.19,1.54.07,3.17-.5,4.52.71h0Z",
    style: {
      fill: "#5271a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.97,438.21c-.42.07-.97.45-1.08-.32-.09-.64-.03-1.31-.03-1.97,0-50.46,0-100.91.03-151.37,0-1.06-.71-2.59,1.17-2.99,2.71,6.56,4.67,13.33,5.6,20.38-.53.51-.55,1.15-.54,1.83.69,33.75.11,67.51.33,101.26.01,1.82-1.06,3.7.18,5.48-.74,7.37-2.52,14.55-4.12,21.75-.45,2-1.02,3.98-1.54,5.96h0Z",
    style: {
      fill: "#98969f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,504.93c-.18-.01-.35-.03-.53-.06-1-1.09-.88-2.44-.88-3.75-.01-5.28-.07-10.55.05-15.82-.06-4.16-.09-8.32.03-12.49.1-6.53.05-13.06.05-20.18-4.29,2.91-7.35,6.31-10.78,9.27-1.7,1.46-3.37,2.97-5.03,4.49-.83.76-1.78,1.49-2.96.49-.38-.58-.44-1.24-.47-1.91.04-8.04-.18-16.08.1-24.11,1.85-2.75,4.66-4.52,7.06-6.7,6.27-5.66,12.59-11.26,18.87-16.91,4.53-4.08,9.11-8.12,13.54-12.32.79-.75,1.61-1.93,2.85-1.3,1.18.6.87,1.95.79,3.07-2.43,7.64-7.07,13.85-12.71,19.36-1.8,1.76-3.66,3.55-5.92,4.77-2.44,1.33-3.22,3.29-3.21,6.03.08,19,.05,37.99.03,56.99,0,2.64.01,5.26,0,7.9-.01,1.13.02,2.28-.87,3.17h0Z",
    style: {
      fill: "#5576a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,666.53c-.43,1.69,1.07,2.43,1.75,3.58,6.9,11.69,13.78,23.39,20.68,35.08,1.71,2.9,3.58,5.72,5.13,8.7.71,1.37,1.63.87,2.57.87-4.91,3.15-10.05,5.89-15.27,8.48-1.79.69-2.32-.75-2.96-1.83-3.64-6.12-7.41-12.16-10.85-18.39-1.04-1.89-2.32-3.63-3.51-5.43-1.03-1.55-1.58-3.17-.94-5.02.71-8.73,1.82-17.41,3.38-26.04h0Z",
    style: {
      fill: "#444086",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.33,249.94c17.79-33.39,35.61-66.76,53.28-100.22,1.49-2.81,2.68-1.77,4.56-.92,2.16.97,2.35,1.98,1.24,4.05-17.87,33.45-35.66,66.95-53.48,100.43-1.73.83-2.66-.86-4-1.26-.64-.62-1.79-.84-1.61-2.09h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.33,250.44c-12.38-23.38-24.78-46.76-37.16-70.13-4.85-9.15-9.61-18.35-14.62-27.42-1.26-2.28-.27-2.97,1.49-3.65,1.52-.59,3.07-2.74,4.42.38,1.35,3.09,3.02,6.05,4.55,9.06.57,1.47,1.48,2.77,2.21,4.15,5.29,9.84,10.61,19.67,15.87,29.53,9.81,18.41,19.58,36.85,29.36,55.27-.25,1.19-1.3,1.56-2.16,2.12-1.32.22-2.27,2.66-3.98.68h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.88,714.16c3.16-3.51,5.11-7.8,7.54-11.77,6.84-11.2,13.47-22.52,20.18-33.78,1-1.68.58-3.44.34-5.19-.45-3.23-.92-6.46-1.35-9.69-.02-.19.32-.42.5-.63,1.82,13.34,3.7,26.68,5.07,40.07.48.7.05,1.22-.31,1.78-5.06,8.01-9.78,16.21-14.55,24.4-1.89,3.25-1.84,3.27-5.09,1.64-4.25-2.02-8.39-4.24-12.34-6.82h0Z",
    style: {
      fill: "#444086",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.55,599.87c-2.45,1.59-1.6,3.15-.36,5.22,5.61,9.33,10.91,18.84,16.53,28.16,2.47,4.09,4.98,8.16,7.31,12.33.48.85.98,1.59.76,2.6-8.95-3.8-17.77-7.87-26.51-12.12-1.75-1.03-2.22-2.97-3.13-4.57-3.67-6.42-7.75-12.61-11.19-19.17-.55-1.05-1.87-2.13-.4-3.46,5.47-3.35,11.2-6.24,16.98-9.01h0Z",
    style: {
      fill: "#444086",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.1,264.75c23.57-28.86,47.16-57.72,70.68-86.63,1.27-1.56,2.07-1.4,3.33-.27,3.39,3.06,3.72,2,.92,5.43-22.9,28.07-45.81,56.14-68.71,84.22-.46.46-1.02.45-1.61.36-1.72-.75-3.98-.73-4.61-3.11h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,265.82c-20.13-24.75-40.26-49.49-60.39-74.23-2.56-3.14-5.05-6.33-7.7-9.39-1.16-1.35-1.09-2.19.38-3.12,1.67-1.05,2.78-3.72,5.25-.49,5.84,7.61,12.05,14.94,18.11,22.38,16.99,20.86,33.99,41.73,50.99,62.59-1.43,2.43-4.63,3.51-6.65,2.25h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.26,575.07c-3.33,7.06-7.78,13.47-11.63,20.22-5.16,9.05-10.6,17.94-15.9,26.91-.49.83-.98,1.61-1.87,2.03,0-9.8,0-19.6,0-29.4-.51-.8-.18-1.69-.25-2.54,5.15-8.3,10.09-16.73,14.96-25.19,4.49,2.25,9.17,4.15,13.17,7.28.42.33,1.01.46,1.52.68h0Z",
    style: {
      fill: "#2c326d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,467.04c-1.7-5.18-2.98-10.47-3.98-15.83.64-1.66.18-3.36.18-5.03.02-53.05.02-106.1.04-159.15,0-1.65-.39-3.43.9-4.86,1.52-.34,2.45,1.42,3.96,1.09,1.22,1.45.92,3.21.92,4.88-.02,16.58-.06,33.16-.04,49.74.05,41.07.03,82.14.05,123.22,0,1.41.14,2.84-.16,4.22-.2.93-.22,2.27-1.86,1.72h0Z",
    style: {
      fill: "#a3a0a8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.53,647c3.55-2.85,4.94-7.16,7.21-10.85,6.74-10.95,13.19-22.09,19.76-33.15.91-1.53,1.49-2.87-.88-3.63-.48-.15-.83-.71-1.24-1.07,4.76,2.06,9.37,4.4,13.69,7.28,1.39.93,2.79,1.8,4.39,2.33.69.85.17,1.61-.22,2.32-4.24,7.8-9.43,15.05-13.26,23.09-.11.23-.42.37-.64.53-7.62,3.57-15.22,7.17-22.86,10.67-1.95.89-3.77,2.1-5.94,2.47h0Z",
    style: {
      fill: "#444086",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.05,231.18c3.59-10.5,6.33-21.24,9.4-31.89,6.72-23.31,13.44-46.62,20.08-69.95.51-1.82,1.24-2.31,2.91-1.56.51.23,1.07.41,1.62.48,2.02.24,2.3,1.22,1.74,3.08-2.91,9.83-5.71,19.69-8.54,29.54-7.18,24.94-14.36,49.88-21.53,74.82-.57.29-1.01-.02-1.45-.31-1.27-1.54-3.74-1.88-4.23-4.21h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,467.04c1-.12,1.11-.84,1.1-1.65-.01-1.41,0-2.82,0-4.24v-177.9c1.13.19,2.26.38,3.39.57,1,.54,1.03,1.45.96,2.42-.23,3.26.05,6.54-.16,9.79-.18,2.97.14,5.65,2.66,7.62-2.22.92-2.53,2.7-2.73,4.91-.37,4.07-.42,8.15-.69,12.23-.44,10.97-1.26,21.91-.93,32.89.02.67.25,1.28.38,1.93.59,1.81-.4,3.49-.38,5.28.08,8.42.68,16.8,1.69,25.15.21,1.76-.25,3.56.29,5.3.21,7.13,1.62,14.13,2.5,21.18.18,1.39.29,2.79.44,4.18-1.88-.28-1.37-1.96-1.75-3.08-.33-.98-.33-2.04-.3-3.07.05,22.58.05,45.16-.01,67.74,0,1.52.54,3.58-1.96,4-1.9-4.97-3.18-10.12-4.51-15.26h0Z",
    style: {
      fill: "#a7a5ac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,232.36c-9.43-32.61-18.87-65.23-28.3-97.84-.18-.63-.37-1.26-.57-1.89-1.18-3.83-1.13-3.7,2.75-5.01,2-.68,2.59-.06,3.1,1.77,3.12,11.04,6.35,22.05,9.53,33.07,5.78,19.96,11.56,39.93,17.34,59.89.54,1.88,1.08,3.76,1.62,5.64-.68,2.53-3.04,4.41-5.48,4.38h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.03,598.23v26.01c-2.13.75-2.54-1.15-3.22-2.28-4.12-6.85-8.23-13.71-12.3-20.6-4.4-7.45-8.77-14.92-13.14-22.39-.74-1.27-2.45-2.65-.75-4.44,3.78-2.44,7.72-4.58,11.86-6.35,5.4,10.28,11.63,20.07,17.55,30.04v.02Z",
    style: {
      fill: "#2c326d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.2,467.05c2.42-.24,3.43-2.47,5.03-3.77,4.2-3.4,8.09-7.2,12.11-10.83.46-.41.84-1.2,1.58-.91.78.31.47,1.14.47,1.75.02,6.28,0,12.57,0,18.85-4.74,5.07-10.2,9.36-15.26,14.08-5.82,5.41-11.85,10.6-17.6,16.11-1.02.97-2.01,1.96-3.29,2.58-.75.01-1.5.02-2.26.03,0-4.48-.02-8.96.03-13.44.01-1.18-.07-2.23-1.19-2.89.29-.42.72-.62,1.19-.6,8.87.41,14.32-4.2,17.58-12,.76-1.76.85-3.62.85-5.51,0-1.19-.27-2.47.76-3.44h0Z",
    style: {
      fill: "#506e9e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.86,277.66c22.34-19.02,44.69-38.04,67.03-57.06,1.93-1.65,3.98-3.17,5.81-4.93,1.29-1.24,2.15-1.2,3.09.25.31.47.67.93,1.09,1.3,1.54,1.35,1.46,2.32-.2,3.73-13.18,11.08-26.26,22.28-39.38,33.44-9.82,8.35-19.64,16.7-29.46,25.05-1.06,1.52-2.47.65-3.74.51-.99-.11-1.95-.42-2.91-.71-.66-.34-1.4-.61-1.33-1.57h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,574.53c-.68,1.82.68,3.05,1.44,4.33,8.25,14.04,16.56,28.04,24.91,42.02.77,1.3,1.13,3.08,3.06,3.36v18.36c-2.15-1.03-2.6-3.08-3.54-4.64-7.44-12.28-14.91-24.55-22.1-36.97-3.81-6.58-7.7-13.11-11.62-19.63-.45-.74-.69-1.54-.64-2.42,2.73-1.66,5.42-3.4,8.49-4.41h0Z",
    style: {
      fill: "#303471",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,416.16c-.74-4.6-1.69-9.19-2.18-13.82-1.56-14.54-2.52-29.11-3.14-43.74-.55-12.98-.04-25.91.4-38.84.43-12.91,1.85-25.77,3.35-38.61.03-.25.27-.48.41-.72,1.45-.66,2.13.1,2.45,1.37.31,1.2.22,2.44.22,3.66,0,41.92.02,83.84-.05,125.77,0,1.69.88,3.85-1.45,4.93h0Z",
    style: {
      fill: "#96959d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,304.73c-6.68,6.03-13.36,12.06-20.04,18.1-10.02,9.07-20.03,18.13-30.02,27.22-6.6,5.99-13.13,12.06-19.76,18.02-8.64,7.78-17.37,15.46-26.01,23.24-3.62,3.26-7.04,6.75-10.66,10.03-9.04,8.18-18.23,16.2-27.17,24.48-3.57,3.31-7.6,6.17-10.54,10.15.37.65-.25.81-.57,1.12-.21.19-.41.38-.62.58-.89.59-1.63,1.32-2.21,2.23-.15.05-.3.08-.46.07-3.69,3.01-7.26,6.17-10.68,9.48-.96.93-1.83,2.24-3.53,1.78v-3.95c2.6-3.26,6.03-5.64,9.07-8.43,6.71-6.17,13.58-12.16,20.34-18.28,10.17-9.2,20.06-18.71,30.38-27.76,8.61-7.57,17-15.4,25.57-23.02,10.12-9,19.81-18.45,29.97-27.41,8.39-7.4,16.67-14.92,24.94-22.45,5.15-4.68,10.27-9.39,15.56-13.91,1.03-.88,2.18-1.45,3.48-1.79,1.04-.15,2.08-.31,2.94.53h.01Z",
    style: {
      fill: "#5271a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.21,279.42c-21.93-19.13-43.85-38.27-65.8-57.37-1.35-1.17-2.48-2.09-.57-3.7,1.45-1.22,2.08-3.82,4.92-1.31,19.7,17.38,39.54,34.61,59.33,51.9,3.26,2.84,6.46,5.76,9.69,8.64-1.59,2.01-4.83,2.8-7.57,1.85h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.12,416.16c.93-.84.55-1.94.55-2.93.02-43.26.02-86.51,0-129.77,0-1.25.7-3.08-1.72-3.03,1.91-1.36,3.42.54,5.15.64,1.12.65,1.35,1.74,1.43,2.9.07,1.03.05,2.07.05,3.1v142.6c0,1.32.07,2.64-.15,3.95-.12.74-.27,1.74-1.14,1.72-.85-.01-1.07-.9-1.05-1.72.02-.39-.08-.74-.3-1.06-1.38-5.39-2.19-10.87-2.82-16.39h0Z",
    style: {
      fill: "#9c9aa2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.57,203.48c1.37-19.7,2.75-39.41,4.11-59.11.58-8.35,1.17-16.71,1.67-25.06.1-1.7.67-2.29,2.41-2.15,4.48.37,4.34.29,3.98,4.73-.68,8.25-1.19,16.51-1.75,24.77-1.4,20.83-2.79,41.67-4.19,62.51-1.35.81-2-.37-2.77-1.03-.9-.78-1.72-1.67-2.57-2.52-.48-.63-1.24-1.15-.89-2.13h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.95,432.55c.96.49.16,1.91,1.35,2.39.66-.68.33-1.56.33-2.31.02-49.43.02-98.86.02-148.28,0-1.13.1-2.27-.55-3.29,1.31.37,2.63.74,3.94,1.1,0,55.49,0,110.98-.07,166.47,0,.77,1.26,2.56-1.05,2.57-1.65-6.15-3.22-12.32-3.98-18.66h0Z",
    style: {
      fill: "#9f9da5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.97,165.05c-2.9-3.18-5.85-6.33-8.69-9.56-1.08-1.23-2.04-1.24-3.42-.49-3.86,2.08-7.79,4.03-12.45,6.41,2.27-4.59,4.05-8.49,6.12-12.23.98-1.76.66-2.74-.7-4.07-3-2.93-5.8-6.06-8.93-9.38,4.48.64,8.81,1.14,13.07,1.93,1.64.31,2.39-.13,3.06-1.54,1.9-3.98,3.92-7.9,6.29-12.67.84,4.88,1.71,8.94,2.18,13.04.26,2.29,1.13,3.22,3.4,3.47,4.08.45,8.12,1.2,12.26,2.38-3.72,1.95-7.38,4.04-11.19,5.8-1.98.92-2.27,2.12-1.91,4.02.78,4.03,1.43,8.08,2.13,12.11-.41.26-.83.52-1.24.78h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.24,162.83c-1.45-1.01-2-2.49-2.21-4.15,1.16,2.8,2.95,2.56,5.3,1.4,3.03-1.5,6.2-2.73,9.35-3.97,1.52-.6,2.12-1.3,1.88-3.13-.56-4.28-.75-8.6-1.15-13.74,3,3.41,5.75,6.16,8.04,9.25,1.81,2.45,3.42,2.8,6.11,1.4,3.39-1.76,7.05-3.01,11.33-4.79-2.53,4.2-4.59,7.82-6.87,11.3-1.15,1.75-1.27,2.97.28,4.61,2.82,2.97,5.38,6.2,7.69,9.91-3.89-.91-7.82-1.66-11.65-2.78-2.36-.69-3.56-.04-4.68,2.05-1.85,3.46-4.02,6.75-6.71,10.06-.29-2.99-.66-5.97-.86-8.96-.41-5.97-.37-5.97-6.2-7.34-2.65-.62-5.3-1.27-7.95-1.91-.8-.2-1.74-.74-1.71.8h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.79,191.77c-4.11-.37-8.23-.67-12.33-1.15-2.09-.24-3.23.36-3.99,2.44-1.41,3.86-3.14,7.6-5.33,11.41-.87-3.57-1.94-7.11-2.54-10.72-.53-3.2-1.81-4.6-5.28-4.46-3.6.14-7.23-.51-11.02-1.46,3.18-1.93,6.29-4.02,9.58-5.75,2.65-1.39,3.56-2.94,2.53-5.96-1.2-3.53-1.82-7.25-2.19-11.29,3.08,2.61,6.28,5.1,9.17,7.89,1.73,1.67,3,1.8,4.98.46,3.37-2.3,6.96-4.28,10.88-6.01-1.6,3.87-3.06,7.8-4.85,11.58-.92,1.94-.5,3.02,1.04,4.27,3.27,2.65,6.41,5.45,9.61,8.19-.08.19-.16.37-.25.55h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,220.52c-5.11.4-9.41.86-13.73,1.02-1.88.07-2.56.77-2.95,2.52-.9,4.08-2.02,8.12-3.73,12.25-1.54-3.77-3.2-7.51-4.59-11.34-.68-1.86-1.44-2.65-3.62-2.38-4.09.5-8.25.58-12.52.85.07-1.37,1.13-1.78,1.83-2.39,2.49-2.15,5-4.29,7.61-6.31,1.41-1.09,1.78-2.1,1.02-3.83-1.74-3.95-3.26-8-5.2-12.86,3.95,2.47,7.33,4.35,10.45,6.61,2.38,1.72,4.07,1.76,6.25-.4,2.71-2.7,5.84-4.98,9.46-8-1.2,4.85-2.11,8.91-3.25,12.91-.59,2.06-.19,3.23,1.75,4.32,3.59,2.02,7,4.35,11.23,7.02h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.86,145.34c4.08,1.71,8.09,3.27,11.98,5.06,1.79.82,2.84.51,4.05-1.01,2.62-3.29,5.47-6.41,8.79-10.26-.42,5.04-.66,9.3-1.17,13.52-.22,1.82.19,2.76,1.91,3.44,4.09,1.62,8.12,3.41,12.86,5.43-4.83,1.14-8.91,2.19-13.03,3.03-2.08.42-2.99,1.35-3.07,3.56-.12,4.02-.56,8.02-.87,12.03-.24.1-.47.2-.71.29-1.37-2.24-2.77-4.46-4.11-6.72-2.47-4.16-6.04-5.69-10.7-4.58-2.54.6-5.08,1.19-8.03,1.21,1.97-2.31,3.91-4.64,5.92-6.91,2.61-2.95,2.89-6.13.84-9.53-1.56-2.58-3.09-5.17-4.63-7.76-.07-.12-.03-.33-.05-.8h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.55,140.77c4.95-.79,9.19-1.57,13.45-2.1,1.78-.22,2.58-.79,2.82-2.68.55-4.28,1.37-8.52,2.24-13.66,2.27,4.5,4.27,8.23,6.04,12.08.84,1.84,1.75,2.45,3.86,2.02,4.13-.83,8.34-1.25,13.34-1.96-2.93,2.91-5.27,5.41-7.79,7.7-3.76,3.43-3.81,3.36-1.49,7.99,1.54,3.08,3.07,6.18,4.22,9.69-3.62-1.88-7.3-3.65-10.82-5.68-1.95-1.12-3.25-1.11-4.86.63-2.83,3.09-5.94,5.92-9.49,9.4.84-4.87,1.47-8.95,2.26-12.98.42-2.14-.03-3.44-2.2-4.42-3.74-1.7-7.3-3.78-11.59-6.05h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.38,220.51c3.87-2.43,6.92-4.64,10.24-6.33,2.94-1.49,3.42-3.32,2.44-6.28-1.14-3.46-1.85-7.05-2.3-11,2.17,1.79,4.37,3.55,6.51,5.38,3.47,2.96,7.1,3.23,10.91.82,2.38-1.5,4.78-2.97,7.93-4.92-1.51,3.87-2.73,7.02-3.97,10.17-1.25,3.17-.62,5.82,1.88,7.95,2.56,2.18,5.12,4.35,8.08,6.85-4.33.54-8.1-.2-11.84-.52-2.89-.25-4.39.36-5.3,3.29-1.1,3.54-2.77,6.9-4.86,10.34-1.01-3.94-2.13-7.84-2.97-11.81-.44-2.09-1.26-2.9-3.51-2.94-4.12-.07-8.23-.59-13.26-1h.01Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.02,273.39c-.28-3.73-.68-7.45-.78-11.19-.07-2.65-.98-3.99-3.77-4.46-3.87-.64-7.67-1.79-12.26-2.91,4.26-1.82,7.79-3.52,11.45-4.82,2.43-.86,3.44-2,3.07-4.7-.54-3.97-.67-8-1.03-12.81,3.08,3.58,5.78,6.53,8.25,9.66,1.5,1.9,2.84,2.51,5.21,1.33,3.62-1.79,7.44-3.16,11.99-5.03-2.26,3.74-4.13,6.88-6.03,10-2.38,3.89-2.38,3.86.61,7.28,2.34,2.67,4.63,5.38,6.67,8.61-3.59-.84-7.24-1.48-10.74-2.58-3.01-.94-4.82-.47-6.27,2.56-1.57,3.27-3.72,6.25-5.62,9.36l-.75-.3h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.54,273.91c-2.2-3.59-4.51-7.13-6.55-10.81-1.03-1.87-2.22-2.13-4.13-1.62-4.07,1.09-8.19,1.97-13,3.11,3.14-3.65,5.8-6.87,8.61-9.95,1.45-1.59,1.85-2.84.46-4.84-2.35-3.38-4.31-7.04-6.87-11.3,4.52,1.86,8.41,3.29,12.15,5.07,2.11,1,3.38.66,4.78-1.13,2.5-3.17,5.21-6.18,8.17-9.65.34,4.68-.44,8.87-.77,13.05-.17,2.14.41,3.01,2.26,3.73,3.92,1.54,7.76,3.27,12.4,5.25-4.8,1.15-8.84,2.18-12.92,3.05-1.87.4-2.9,1.08-2.98,3.25-.16,4.2-.66,8.38-1.02,12.57-.19.06-.38.13-.57.19h-.01Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.16,191.21c3.19-2.74,6.33-5.55,9.6-8.2,1.56-1.26,1.95-2.35,1.03-4.28-1.78-3.72-3.23-7.59-4.44-11.93,2.16,1.3,4.33,2.57,6.48,3.89,4.43,2.71,8.59,2.37,12.48-1.04,1.88-1.65,3.79-3.25,6.32-5.41-1.18,5.09-2.09,9.39-3.2,13.64-.41,1.56-.07,2.37,1.32,3.17,3.72,2.15,7.35,4.47,10.93,7.4-3.66.31-7.33.94-10.99.85-3.34-.09-4.6,1.23-5.1,4.35-.58,3.66-1.62,7.24-3.09,10.95-1.52-3.68-3.22-7.3-4.51-11.06-.88-2.56-2.28-3.23-4.83-2.88-3.9.53-7.84.76-11.76,1.12-.07-.19-.15-.37-.23-.57h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.47,205.83c-1.59-24.02-3.17-48.05-4.77-72.06-.32-4.78-.63-9.57-1.07-14.34-.18-1.92.6-2.68,2.36-2.4,1.52.24,3.87-1.49,4.07,1.99.55,9.38,1.36,18.75,2.01,28.13,1.22,17.64,2.4,35.28,3.6,52.92.14.23.18.48.11.75-1.48,2-3.23,3.73-5.21,5.23-.41.12-.78.1-1.1-.21h0Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.18,134.12c4.38,0,8.75-.08,13.13.04,1.68.05,2.31-.67,2.72-2.13,1.19-4.15,2.48-8.27,4.34-12.57,1.07,3.13,2.17,6.25,3.22,9.39,1.14,3.4,3.49,5.1,7.05,5.1h10.59c-3.79,2.87-7.18,5.5-10.65,8-1.43,1.03-1.87,2.01-1.2,3.76,1.53,4.02,2.83,8.12,3.82,12.55-3.49-2.43-7.05-4.77-10.45-7.32-1.57-1.18-2.67-1.12-4.17.1-3.29,2.65-6.72,5.12-10.82,8.21,1.14-3.8,2.03-6.85,2.97-9.89,1.13-3.63.19-6.54-2.82-8.7-2.52-1.81-5.06-3.6-7.59-5.4-.07-.05-.12-.15-.18-.22.01-.31.03-.62.04-.93h.01Z",
    style: {
      fill: "#f8f15e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.34,415.61c1.54.81,1.06,2.28,1.06,3.52.02,18.53.02,37.05.01,55.57,0,1.7-.03,3.38,1.15,4.78-2.09,6.5-4.2,12.99-7.49,19.02-.22.4-.29.88-.43,1.32-1.18,1.36-1.56.16-1.92-.66-.7-1.59-.65-3.31-.66-5-.01-12.62,0-25.23-.03-37.84,0-1.01.62-2.35-.98-2.87,2.43-9.32,5.2-18.55,7.13-27.99.67-3.29,1.43-6.57,2.14-9.86h0Z",
    style: {
      fill: "#a4a2a9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.14,668.96c6.38-.01,12.77.04,19.15-.08,2.38-.05,2.25.87,1.32,2.44-4.63,7.8-9.26,15.6-13.84,23.44-.54.93-1.17,1.4-2.22,1.35-5.21-2.6-10.3-5.4-15.25-8.47-.01-.48.11-.94.36-1.34,3.62-5.7,6.84-11.65,10.48-17.34h0Z",
    style: {
      fill: "#313572",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.63,410.5c-.42.07-.98.45-1.08-.32-.09-.64-.03-1.32-.03-1.97,0-34.67-.01-69.34.06-104,0-.71-1.08-2.41,1.09-2.27.41,4.56,1.87,8.92,2.45,13.48.84,6.5,1.58,13.02,1.94,19.54.47,8.62,1.1,17.26.6,25.9-.64,11.12-1.05,22.25-2.52,33.32-.73,5.47-1.72,10.88-2.49,16.33h0Z",
    style: {
      fill: "#95939b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.94,504.93c.05-23.32.11-46.64.09-69.97,0-1.95.66-3,2.27-4.04,9.37-6.07,16.04-14.33,19.75-24.91,1.33-6.51,3.24-12.93,3.15-19.67-.02-1.21.15-2.48-.94-3.39-1.39-1.01-3.14-1.16-4.6-2.05-3.36-2.06-5.4-5.08-6.64-8.74-.2-.98-.2-2-.46-2.97-.05-.29-.06-.59-.03-.89,1.23-8.62,4.89-12.8,12.4-14.28,2.9-.57,5.58.2,8.25,1.12,3.33,1.99,6.06,4.54,7.58,8.2,2.52,8.66-.97,15.77-9.43,18.88-1.72.63-2.37,1.63-2.28,3.35.38,7.17-1.93,13.79-4.21,20.41-3.24,7.8-7.41,14.98-13.62,20.84-2.13,2.01-4.29,4-6.82,5.44-1.76,1-2.13,2.27-2.13,4.13,0,16.28-.09,32.55-.15,48.83-.76,5.82-.16,11.67-.33,17.51-.04,1.28.06,2.54-1.84,2.21h0Z",
    style: {
      fill: "#fbfcfd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.81,490.22c.01-4.71.02-9.42.03-14.13,5.37-5.06,10.74-10.11,16.41-14.83.85-.71,1.74-1.09,2.8-.45,3.74,1.27,5.61,3.9,5.61,7.88,0,11.1.02,22.19,0,33.29,0,.97.46,2.09-.53,2.9-.84-.9-.87-2.04-.87-3.16,0-4.48-.1-8.97.05-13.45.16-4.38.1-8.77.07-13.67-4.31,3.01-7.47,6.49-11.02,9.5-3.36,2.86-6.44,6.06-9.94,8.77-.81.63-1.67,1.71-2.86.49.07-1.05-.29-2.13.24-3.14h0Z",
    style: {
      fill: "#4d6898",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.41,482.31c1.57-.79,1.1-2.25,1.1-3.49.02-22.27.02-44.55.01-66.82,0-1.5-.08-3,.83-4.34,1.14,2.94.67,6.22,2.08,9.07,1.66,8.25,3.33,16.51,4.99,24.76.42,2.11.83,4.22,1.24,6.33-1.5.05-1.45-1.25-1.76-2.14-.57-1.68-.85-3.44-1.42-5.36,0,17.99,0,35.76,0,53.53,0,1.03.07,2.09-.23,3.09-.24.77-.44,1.78-1.69,1.2-1.63-5.3-3.87-10.41-5.16-15.83h0Z",
    style: {
      fill: "#adabb1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.24,504.91c3.82-4.81,8.82-8.41,13.15-12.7,2.86-2.83,6.02-5.35,9.01-8.05,4.25-3.83,8.47-7.7,12.72-11.51.32-.29.84-.34,1.27-.5,0,4.34,0,8.68-.01,13.02-.58,1.2-1.42,2.21-2.41,3.09-6.29,5.62-12.15,11.73-19.04,16.67h-14.7.01Z",
    style: {
      fill: "#4e6b9b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.4,667.07c-.05,5.99-5.13,10.99-11.08,10.88-5.83-.1-10.9-5.11-10.95-10.82-.05-5.94,5.29-11.29,11.18-11.2,6.01.1,10.9,5.12,10.85,11.14h0Z",
    style: {
      fill: "#212f6d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06,507.4c-.01-6.01,4.94-10.95,10.97-10.95,5.99,0,11,4.99,11.02,10.97.02,5.82-5.17,10.99-11.04,11.01-5.94.02-10.92-5.01-10.93-11.03h0Z",
    style: {
      fill: "#212f6d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.03,598.23c-3.39-2.74-4.84-6.83-7.08-10.35-3.33-5.21-6.23-10.68-9.39-15.99-.7-1.18-1.16-2.34-1.07-3.7,5.49-3.29,11.19-6.19,16.93-9.01,1.04.9.61,2.11.61,3.18.03,11.96.02,23.92.01,35.87h0Z",
    style: {
      fill: "#262e67",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,608.88c-.64,1.07.27,1.74.67,2.52,4.38,8.4,9.87,16.16,14.04,24.67-7.36-3.3-14.73-6.59-22.09-9.91-4.42-2-8.81-4.06-13.72-6.32,7.32-3.81,14-7.77,21.09-10.96h0Z",
    style: {
      fill: "#49438b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,283.29c5.06-.96,10.12-1.93,15.17-2.89,3.93-.8,4.38-.52,4.34,3.49-.06,4.94.43,9.9-.32,14.83-.64,1.5-2.13,1.61-3.41,2.07-4.22.74-8.37,1.96-12.71,1.93-3.44-.28-3.87-.67-3.93-4.03-.08-4.31.02-8.63-.06-12.94-.02-.93-.08-1.91.92-2.48h0Z",
    style: {
      fill: "#f2efed",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,692.57c.05,1.31.11,2.51.93,3.72,5.49,8.08,9.98,16.76,15.12,25.05.55.89.93,1.88,2.2,1.9-3.81,2.59-7.87,4.73-12.01,6.73-1.52.68-2.21-.46-2.92-1.39-2.35-3.03-3.72-6.67-6-9.75-.6-.8-.57-1.85-.35-2.71.55-2.17.34-4.41.77-6.57.45-5.7,1.12-11.37,2.25-16.99h.01Z",
    style: {
      fill: "#49428b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.22,720.98c2.43,1.26,3.46-.02,4.61-2.08,4.45-7.92,9.12-15.72,13.69-23.58.46-.8,1.67-1.01,1.65-2.16,1.17,4.98,1.46,10.08,2.19,15.13.31,2.12.42,4.25.62,6.38.53.79.1,1.5-.34,2.07-2.36,3.08-3.94,6.63-6.04,9.86-.75,1.15-1.43,2.61-3.29,1.69-4.51-2.19-8.91-4.55-13.1-7.31h0Z",
    style: {
      fill: "#48428b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.33,633.86c2.44-7.14,7.2-13.01,10.74-19.54,1.15-2.12,2.69-4.04,3.39-6.4,4.61,1.87,8.88,4.43,13.3,6.71,2.15,1.11,4.26,2.3,6.88,3.72-4.63,2.13-8.78,4.06-12.95,5.94-7.11,3.21-14.23,6.38-21.35,9.57h0Z",
    style: {
      fill: "#49438b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.82,493.62c1.93-.44,3.13-2.01,4.5-3.18,5.79-5,11.42-10.21,17.12-15.31.67-.59,1.22-1.89,2.15-1.49,1.11.48.49,1.85.51,2.81.07,3.66.02,7.31.02,10.97-6.05,6.02-12.46,11.63-18.65,17.5-1.88,0-3.77.01-5.66.01-.45-3.77-.45-7.53,0-11.3h0Z",
    style: {
      fill: "#4b6594",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.06,453.46c.99-.16.48-1.64,1.59-1.76.57.84.25,1.78.25,2.66.02,13.6.04,27.2-.01,40.8,0,1.53.36,2.96.63,4.42.14.75.7.34,1.1.27-.99,5.16-1.13,5.24-8.49,5.08-1.03-1.18-.85-2.64-.86-4.03-.02-7.7,0-15.39-.01-23.09,0-1.41.11-2.84-.97-3.99,2.25-6.79,4.51-13.57,6.76-20.35h0Z",
    style: {
      fill: "#a8a6ad",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.56,498.14c1.79-.55,1.01-2.05,1.01-3.1.05-17.42.05-34.84.01-52.25,0-1.8.24-3.51.9-5.56,1.56,3.61,1.35,7.43,3.17,10.59,1,2.95,1.8,5.94,2.18,9.04-.44,2.32-.21,4.67-.21,7-.04,12.15,0,24.31-.03,36.46,0,1.58.27,3.23-.9,4.6-2.85.68-4.36-.61-5-3.31-.28-1.18-.75-2.31-1.13-3.47h0Z",
    style: {
      fill: "#b3b1b6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.14,668.96c-.26,3.05-2.54,5.1-3.87,7.62-2.04,3.86-4.26,7.62-6.97,11.07-.43,0-.84-.03-1.06-.48-.76-.96-1.92-1.27-2.95-1.79-3.51-1.66-6.95-3.44-10.15-5.66,1.33-.57,2.18-1.54,2.8-2.86,1.32-2.76,2.78-5.45,4.67-7.89h17.54Z",
    style: {
      fill: "#2c326d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.57,567.11c-.15,2.79-2,4.82-3.29,7.07-3.03,5.29-6.15,10.54-9.3,15.76-.5.82-.85,1.96-2.12,2.06-.58-1.35-.25-2.77-.26-4.15-.03-8.6-.05-17.2.02-25.79,0-.8-.81-2.18.94-2.39,4.78,2.25,9.46,4.72,14,7.43h0Z",
    style: {
      fill: "#272f67",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.05,460.82c-2.58.19-3.96,2.29-5.67,3.75-4.11,3.52-8.04,7.23-12.07,10.83-.39.34-.98.47-1.48.7v-16.97c2.58-3.65,6.17-6.26,9.52-9.11.61-.51,1.44-.95,2.35-.5.46,5.06,3.57,8.4,7.35,11.31h0Z",
    style: {
      fill: "#506d9d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.31,473.81c.76-.49,1.64-1.34,1.81.44.09.93.03,1.87.03,2.81v27.86c-4.77-.02-9.55-.03-14.32-.05,3.05-7.48,6.13-14.94,9.16-22.43,1.16-2.86,2.22-5.76,3.32-8.64h0Z",
    style: {
      fill: "#adaab0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.95,299.09c0-5.05-.13-10.11.06-15.15.1-2.73-.33-4.38-3.54-3.54.58-.33,1.16-.66,1.75-.98,2.63-.18,5.16-.78,7.57-1.85,1.87-.11,3.7-.44,5.46-1.09,1.74.02,1.89,1.37,1.93,2.55.18,4.86.15,9.73.02,14.6-.03,1.3-.57,2.35-1.68,3.07-3.15,1.66-6.66,2.09-10.06,2.87-.55.12-1.1-.03-1.52-.48h0Z",
    style: {
      fill: "#e9e6e5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,668.8c.34.25.68.5,1.01.75.77.16,1.17.72,1.46,1.39.62.97,1.06,2.01,1.09,3.17.14,6.5.19,13-.04,19.5-.05,1.41.03,3.5-2.55,3.05-6.01-5.68-12.33-11.06-17.58-17.5.24-.22.51-.3.83-.24,3.16,1.93,5.19,5.13,8.07,7.38.92-.51.62-1.35.63-2.02.05-3.57.03-7.15.02-10.73,0-3.84-.02-3.85-4-3.86-1.6,0-3.2,0-4.81.05-3.41-.21-6.92.83-10.2-.83-.14-.88.56-.53.88-.53,7.67-.02,15.33-.02,23,.02.73,0,1.45.27,2.18.41h0Z",
    style: {
      fill: "#c9c6c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,668.96c5.09,0,10.18,0,15.27,0,1.97,2.53,3.51,5.33,4.87,8.22,1,2.13,2.19,3.22,4.57,1.85.63-.36,1.41-.61,2.05.14-4.97,3.07-10.06,5.92-15.31,8.48-1.2.31-1.69-.62-2.19-1.36-3.34-4.91-6.06-10.2-9.17-15.25-.38-.63-.72-1.37-.08-2.08h0Z",
    style: {
      fill: "#2c326d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7,504.92v-43.29c0-1.69-.03-3.37,1.15-4.77,1.87,6.41,3.73,12.83,5.6,19.23-.96,1.22-.16,2.54-.17,3.8-.06,7.19-.01,14.39-.04,21.58,0,1.21.02,2.45-.89,3.44h-5.66,0Z",
    style: {
      fill: "#b9b6bb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,668.96c3.48,6.44,6.67,13.05,11.45,18.7-2.53,1.73-5.16,3.29-8,4.47-1.57.02-1.96-1.38-2.54-2.34-3.69-6.06-7.28-12.2-10.93-18.29-1.16-1.93-.66-2.68,1.58-2.6,2.81.11,5.63.05,8.44.06h0Z",
    style: {
      fill: "#303471",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.16,227.84c3.27-2.99,6.49-6.03,10.17-8.53-1.49,8.28-.84,16.6-.46,24.92-.11,1.01-.62,1.8-1.32,2.51-2.13,1.67-4.3,3.3-6.51,4.87-.86.61-1.83,1.57-2.83.12-.89-4.28-.31-8.61-.45-12.91-.08-2.62.06-5.25-.07-7.88-.06-1.33.25-2.41,1.46-3.1Z",
    style: {
      fill: "#a4a2a8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.76,269.67c3.32.81,6.49,2.05,9.61,3.4,1.44.44,2.1,1.35,2.05,2.92-.15,4.7-.01,9.4-.08,14.11-.03,1.83-.37,3.43-2.69,3.54-1.18.11-2.32,0-3.39-.53-1.87-1.25-4.15-1.49-6.1-2.53-.8-.42-2.15-.58-1.47-2.1.99-1.23,1.2-2.68,1.2-4.2,0-3.63-.02-7.26,0-10.89.01-1.3-.1-2.63.85-3.72h0Z",
    style: {
      fill: "#e4e1e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.29,441.04c3.81,4.63,3.87,10.69.15,14.89-4.2,4.73-9.64,5.52-14.86,2.15-3.1-2.7-3.14-2.74-.28-5.55,3.92-3.85,8.12-7.41,12.24-11.05.8-.71,1.67-1.25,2.74-.44h0Z",
    style: {
      fill: "#4e6a9a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.28,184.32c1.48-1.86,2.94-1.83,4.39.08,1.38,1.84,2.72,3.72,4.08,5.58.77,1.03.92,2.22.9,3.46-.07,6.84,0,13.67-.05,20.51-.01,1.31-.02,2.64-.76,3.8-.98,1.24-1.85.44-2.61-.23-1.98-1.75-3.84-3.61-5-6.05-.74-1.78-.67-3.66-.71-5.54-.12-7.2.29-14.42-.24-21.61h0Z",
    style: {
      fill: "#a6a4ab",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.18,681.92c-17.2,17.59-35.34,34.16-54.83,49.2-.53.2-.71-.13-.85-.54-.05-.58.22-1.04.56-1.48,1.43-1.68,3.57-2.6,4.79-4.52.38-.52.83-.96,1.41-1.24.91-.33,1.65-.9,2.3-1.62.87-.83,1.69-1.71,2.58-2.52.18-.16.38-.31.58-.44.74-.42,1.36-.97,1.94-1.59,1.15-1.11,2.3-2.23,3.31-3.48,2.43-1.44,4.25-3.56,6.22-5.52,2.25-2.05,4.83-3.74,6.61-6.28,1.93-1.87,4.01-3.59,5.82-5.59,1.78-1.69,3.44-3.48,5.23-5.16,3.05-2.42,6.02-4.9,8-8.36.32-.57.84-.98,1.38-1.35,2.37-1.76,4.24-4.05,6.35-6.08,2.44-2.09,4.26-4.85,7.08-6.53,1.06-.31,2.12-.75,3.45.06-3.52,4.82-8.07,8.63-11.92,13.05h0Z",
    style: {
      fill: "#415383",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.61,284.95c3.98.05,7.96.1,11.94.15,1.85.37,1.91,1.85,1.93,3.26.08,4.3.11,8.61,0,12.92-.08,3.22-1.31,4.13-4.5,3.54-.64-.12-1.24-.42-1.91-.35-2.71,0-5.42.03-8.13-.02-.77-.02-1.71.4-2.28-.56.05-.08.07-.23.14-.24,3.93-.79,3.86-3.7,3.68-6.77-.23-3.98.49-8.03-.87-11.93h0Z",
    style: {
      fill: "#b9b6bb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.61,284.95c1.2.67,1.8,1.52,1.75,3.08-.15,4.11-.2,8.24,0,12.35.12,2.54-.6,3.7-3.24,3.26-.45-.07-.93.01-1.4.02-2.37.16-4.79.94-7.02-.58-.98-2.16-.46-4.45-.56-6.68-.19-4.19.5-8.44-.84-12.56,3.77.34,7.58.27,11.3,1.11h.01Z",
    style: {
      fill: "#c0bdc1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.94,504.91c4.51-4.89,9.87-8.86,14.62-13.5,2.21-2.15,4.55-4.17,6.83-6.25,0,6.58.01,13.15.02,19.72-7.15.01-14.31.02-21.47.03h0Z",
    style: {
      fill: "#4c6897",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.03,278.68c2.31-.1,4.43,1.47,6.8.75,1.12,1.61,3.11.84,4.52,1.65,1.43.75,1.37,2.14,1.4,3.44.06,3.66.03,7.33.02,10.99-.02,4.79-.25,5-5.12,4.95-2.06.06-4.06-.36-6.03-.87-.94-.24-2.09-.33-2.3-1.65.79-1.52,1.03-3.13,1.01-4.84-.06-4.81.11-9.63-.31-14.44h0Z",
    style: {
      fill: "#d2cfd0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.71,259.55c3.95,1.86,7.89,3.72,11.84,5.58,1.22.72,1.44,1.91,1.45,3.16.07,4.87.08,9.75,0,14.62-.02,1.12-.1,2.28-1.21,2.98-1.91.74-3.49-.38-5.17-.92-1.61-.74-3.19-1.55-4.81-2.27-.74-.33-1.98-.5-1.43-1.89,1.24-.71,1.39-1.85,1.39-3.15,0-4.51-.11-9.03.07-13.54.05-1.11-.2-2.01-1.11-2.73-.58-.45-1.23-.92-1.01-1.84h0Z",
    style: {
      fill: "#efecea",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.12,696.7c-1.66,2.17-3.84,3.79-5.9,5.54-1.73-.12-1.81-1.49-1.84-2.67-.14-6.69-.1-13.38-.03-20.07.03-2.63,2.6-3.57,3.64-5.52,1.58-1.7,3.16-3.39,4.74-5.1.09-.04.18-.1.26-.11,8.88-.66,17.76-.7,26.64.03-2.24,2.33-4.48,4.67-6.72,7-.91-1.83.98-4.44-1.12-5.72-1.76-1.06-4.05-.25-6.11-.38-3.17.1-6.35.08-9.51.02-3.4.76-4.11,1.68-4.04,4.94.15,7.34.18,14.68-.02,22.02h0Z",
    style: {
      fill: "#ece9e7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.29,441.04c-2.9.12-4.08,2.81-6.06,4.25-2.94,2.14-5.33,5.02-8.15,7.35-2.17,1.79-2.89,3.39-.5,5.44-3.71-2.01-6.22-7.19-5.41-11.17,1.1-5.41,5.13-9.48,9.86-9.83,4.01-.29,7.71.39,10.26,3.96h0Z",
    style: {
      fill: "#506e9e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.25,292.88c1.39.11,2.29-.15,2.28-1.92-.03-5.32.03-10.65.2-15.97.03-1.18-1.06-1.18-1.36-1.92,3.69.78,7.2,2.14,10.74,3.42.24.28.54.59.58.94.59,5.67.42,11.34.1,17.02-.06,1-.74,1.69-1.78,1.9-.86.19-1.71.13-2.57-.03-2.07-.47-4.2-.72-6.17-1.58-.88-.38-2.09-.44-2.02-1.86h0Z",
    style: {
      fill: "#dcdada",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,296.36c1.1-.76,1.78-1.57,1.73-3.14-.16-4.6-.06-9.22-.06-13.83,0-1.12.18-2.31-1.15-2.92,2.93-1.16,5.9-2.21,8.99-2.85,2.08-.77,2.43.64,2.57,2.13.2,2.23.09,4.47.08,6.71-.02,3.26.04,6.53.14,9.78-1.11,2.75-4.02,2.32-6.07,3.4-2.09.15-3.99,1.96-6.24.7Z",
    style: {
      fill: "#e1dede",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.81,679.18c-.37.04-.77,0-1.1.14-4.35,1.67-4.45,1.72-6.48-2.66-1.21-2.61-3.46-4.69-3.9-7.68,8.83-.01,17.67-.03,26.51-.03.82,0,1.72-.22,2.35.59-5.66,3.46-11.46,6.64-17.37,9.65h0Z",
    style: {
      fill: "#272f67",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,265.82c2.67.59,4.57-1.1,6.65-2.25.4-.04.8-.08,1.19-.11,1.6.24,1.42,1.58,1.43,2.59.06,5.68.25,11.37-.09,17.04-.31,1.72-1.68,2.35-3.08,2.94-2.23.94-4.52,1.74-6.67,2.9-1.19.42-2.4,1.1-3.55-.11,3.37-2.43,2.74-6.03,2.66-9.4-.1-3.82.66-7.71-.9-11.41.61-.92,2.25-.72,2.35-2.17h0Z",
    style: {
      fill: "#d0cecf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.91,304.23c3.81-.07,5.71-2,5.71-5.8,0-3.46-.02-6.91.01-10.37.01-1.15.03-2.25-1.08-2.96,4.3-.02,8.61-.05,12.91-.07-1.49,2.01-1.36,4.34-1.41,6.67-.08,4.02.43,8.06-.33,12.07-.22.5-.67.74-1.14.95l-.24-.03-.24.03c-1.13,0-2.26,0-3.38.01-3.21.84-6.41,1.78-9.62.01-.35,0-.71-.02-1.06-.02-.2-.07-.29-.16-.27-.29.03-.14.07-.21.13-.21h0Z",
    style: {
      fill: "#b2afb5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.87,285.61c.88-.13,1.27-.63,1.27-1.53-.02-5.79,0-11.59-.05-17.38,0-.53-.35-1.05-.54-1.57.19-.12.37-.25.55-.38,1.11,1.6,3.21,1.53,4.56,2.7,1.31.55,2.6,1.14,3.9,1.69.4.18.79.36,1.19.53,0,5.32,0,10.63,0,15.94,0,1.63,0,3.3-2.31,3.38h-.38c-1.48-.38-2.88-1.11-4.46-1.1-1.49-.36-3.14-.46-3.73-2.28h0Z",
    style: {
      fill: "#eae7e6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.71,259.55c3.28,1.41,3.06,4.12,2.88,7.06-.24,4.12-.19,8.27,0,12.39.08,2.01-.67,2.39-2.36,2.03-.9.67-1.7.09-2.52-.2-1.75-1.17-4.3-1.36-4.94-3.94-.36-5.58-.21-11.17-.08-16.74.03-1.46.02-3.44,2.56-2.91,1.66.44,3.08,1.35,4.46,2.31h0Z",
    style: {
      fill: "#f5f2ef",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.25,244.93c-1.13-6.71-.33-13.49-.64-20.22-.1-2.09.35-3.85,1.72-5.4,1.92-2.06,3.61-4.36,6.22-5.66.38,8.57.71,17.15-.16,25.71-1.86,2.52-3.65,5.13-7.14,5.58h0Z",
    style: {
      fill: "#9d9ba2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.47,239.84c.55-1.14.54-2.36.53-3.59-.07-6.86-.08-13.72-.22-20.58-.02-.89.63-1.32.77-2.03,1.97-2.91,5.36-4.55,6.92-7.82.33,0,.67-.01,1.01-.02-1.4,6.63-.68,13.35-.84,20.02-.05,2.15.05,4.3.26,6.44-.01,1.01-.48,1.81-1.13,2.53-1.56,1.62-3.5,2.79-5.08,4.41-.57.59-1.27,1.17-2.23.64h0Z",
    style: {
      fill: "#98969f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.35,295.74c1.85.11,1.77-1.15,1.76-2.43-.02-5.6,0-11.21,0-16.82,2.32-.02,4.32,1.8,6.75,1.16.39.34.78.68,1.17,1.02.55.72,1.18,1.32,1.16,2.41-.07,4.85-.05,9.71-.02,14.57,0,1.27-.31,2.22-1.77,2.35-2.62.84-7.41-.36-9.04-2.27h0Z",
    style: {
      fill: "#d8d5d6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.17,218.28c.54-1.62.6-3.29.59-4.99-.03-7.77-.02-15.54-.02-23.31,2.39,2.71,4.84,5.37,6.82,8.4.49.87.39,1.81.37,2.75-.17,6.21-.02,12.42-.08,18.63-.01,1.4.11,2.84-.61,4.13-.41.57-1.03,1.02-1.62.55-2.16-1.74-4.75-3.14-5.44-6.18h0Z",
    style: {
      fill: "#acaab0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.47,504.91c.45-2.13,2.32-3.14,3.7-4.46,4.34-4.14,8.82-8.13,13.24-12.18.5-.46.99-.87,1.71-.86,0,5.82,0,11.66,0,17.48-6.22,0-12.44.01-18.66.02h0Z",
    style: {
      fill: "#486090",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.26,299.73c3.1-.1,4.64-1.76,4.64-4.97,0-3.57,0-7.13,0-10.7,0-1.04.03-2.07-.55-2.99,3.01.55,6.03,1.11,9.04,1.66.82.42,1.28,1.14,1.29,2.03.04,5.58.62,11.18-.33,16.74-.18.29-.42.51-.74.64-1.43.1-2.86-.1-4.29.02-2.99-.17-5.96-.38-8.76-1.59-.28-.21-.38-.49-.3-.84h0Z",
    style: {
      fill: "#cbc8cb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,504.92c0-8.69-.02-17.37.03-26.06,0-.98-.63-2.36,1.06-2.76,3.2,8.99,6.4,17.97,9.59,26.96.22.62.44,1.24.65,1.85-3.78,0-7.56,0-11.33,0h0Z",
    style: {
      fill: "#bfbcc0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,284.49c3.56.37,7.13.73,10.69,1.1.42,6.38.87,12.76-.29,19.13-2.76,1.74-5.5.56-8.26-.05-1.88-.87-1.89-2.6-1.91-4.29-.07-5.29.11-10.59-.24-15.88h0Z",
    style: {
      fill: "#b5b3b8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.28,184.32c1.56.28,1.1,1.53,1.1,2.46.03,5.8.01,11.6.02,17.41,0,2.61-.16,5.23.57,7.78-.21.52-.65.85-1.04,1.23-1.55,1.24-2.55,3.25-4.82,3.49-1.36-.36-1.69-1.46-1.7-2.61-.07-7.67-.36-15.35.14-23.03,1.39-2.69,3.94-4.39,5.73-6.74h0Z",
    style: {
      fill: "#9f9da5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.36,301.95c.7-.54.58-1.31.58-2.05,0-4.93-.01-9.85.01-14.77,0-.87-.16-1.66-.57-2.4,2.64.37,5.28.74,7.91,1.11,1.24.64,1.78,1.52,1.74,3.05-.12,5.4-.05,10.8-.05,16.21-.4.33-.84.24-1.28.12-1.38-.18-2.74.13-4.12.09-1.46-.32-3.36.76-4.24-1.36h.01Z",
    style: {
      fill: "#c6c4c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.41,226.15c2.21,1.53,4.4,3.09,6.25,5.06-.7,7.8-.28,15.61-.32,23.42-.84,1.31-1.59.43-2.35-.1-1.71-2.12-4.66-3-5.75-5.74-.87-6.83-.41-13.68-.27-20.52.03-1.29.53-2.69,2.44-2.13h0Z",
    style: {
      fill: "#cccacc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.85,283.3c0,6.41,0,12.82-.01,19.23-2.16.97-4.63,0-6.78,1.09-1.15.48-2.31.4-3.47.06,1.7-5.36.67-10.87.86-16.31.03-1-.35-2.05.35-2.97,2.99-.59,6-1.01,9.05-1.1h0Z",
    style: {
      fill: "#a5a2a9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.16,227.84c-.44.79-.68,1.52-.66,2.55.15,7.26.09,14.52.1,21.77-.83,2.28-2.8,3.35-4.73,4.44-.77.44-1.6.5-2.24-.34-.27-.4-.49-.83-.5-1.29-.21-6.97-.48-13.93.11-20.9.41-.57.81-1.14,1.22-1.71,2.25-.93,4.09-2.36,5.48-4.38.41-.05.81-.1,1.22-.15h0Z",
    style: {
      fill: "#a9a7ad",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.61,668.96c-1,3.83-3.81,6.74-5.24,10.36-.45,1.15-1.5.18-2.24.39-6.32-3.15-12.46-6.63-18.53-10.24.65-.77,1.55-.54,2.36-.54,7.88,0,15.76.02,23.63.03h0Z",
    style: {
      fill: "#272f67",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.95,267.99c1.87.44,1.73,1.95,1.74,3.33.03,3.73-.24,7.48.08,11.18.27,3.12-.5,5.3-3.43,6.56-1.26,1.7-2.72,2.7-4.84,1.35-.94-2.65-.57-5.4-.55-8.1.02-3.85-.3-7.7.18-11.54,2.02-1.54,4.64-1.62,6.81-2.78h0Z",
    style: {
      fill: "#d7d4d5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.39,224.52c.61-1.01.59-2.13.59-3.25-.01-6.07.02-12.13-.02-18.2-.01-1.6.13-3.16.61-4.68,2,1.37,3.27,3.46,5,5.09.43.57.86,1.14,1.3,1.7-.64,8.39-.37,16.8-.23,25.19-.12.77-.59,1.39-1.29.81-2.34-1.89-5.04-3.5-5.95-6.67h0Z",
    style: {
      fill: "#b1afb5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.41,226.15c-1.11.09-1.71.69-1.71,1.8,0,6.71.02,13.43.07,20.14,0,.44.3.88.46,1.31-3.66-.49-5.88-2.8-7.48-5.91-.33-6.47-.19-12.94-.07-19.41.03-1.41.01-3.09,1.93-3.59,2.56,1.53,4.71,3.56,6.8,5.64h0Z",
    style: {
      fill: "#c6c3c6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.2,231.22c-.97-2.73-.51-5.57-.55-8.36-.07-4.5-.01-9.01-.02-13.51,0-1.52.1-2.99,1.23-4.17,1.85,1.07,2.66,3.43,4.93,3.99.03.36.06.72.09,1.09.5.87.37,1.8.34,2.74-.17,6.18-.02,12.35-.08,18.52-.02,1.63.44,3.13.98,4.63.07,1.17-.77,1.31-1.4.84-2.15-1.59-4.46-3.09-5.51-5.76h0Z",
    style: {
      fill: "#b7b5ba",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.24,234.06c.62,1.01.58,2.12.58,3.25-.01,5.4,0,10.8-.01,16.2,0,1.13-.01,2.23.59,3.25-.12,2.1-2.3,2.22-3.33,3.46-1.27.64-2.4,2.43-3.99.49-.76-4.29-.2-8.6-.35-12.91-.07-2.15.1-4.32-.14-6.46-.16-1.48.35-2.55,1.55-3.35,1.42-1.66,3.2-2.86,5.1-3.9h0Z",
    style: {
      fill: "#adabb1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.77,235.16c.32.18.64.36.96.54,1.75,1.33,3.49,2.66,5.24,3.99-.66,5.47-.23,10.98-.35,16.46-.04,1.76.07,3.55-.49,5.26-.68,1.15-1.57.64-2.35.21-1.27-.71-2.53-1.46-3.53-2.56-.2-.26-.38-.54-.55-.83-.67-.96-.95-2.04-.93-3.18.08-5.52-.2-11.04-.01-16.56.05-1.4-.21-3.17,2.01-3.33h0Z",
    style: {
      fill: "#d7d4d5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.95,236.98c-1.59-1.59-1.74-3.55-1.7-5.68.09-5.45.06-10.89.01-16.34-.02-1.61.12-3.17.62-4.71,2.05,1.91,4.1,3.82,6.15,5.74-.43,6.49-.11,13-.22,19.49-.02,1.41.12,2.83-.33,4.21-1.98,1.38-3.56.44-4.53-2.71h0Z",
    style: {
      fill: "#bcbabe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.76,261.83c0-6.71.02-13.41.01-20.12,0-.93.33-1.62,1.2-2.03,2.05,1.06,3.96,2.33,5.58,4,.57,5.2.21,10.42.28,15.64.03,2.15.07,4.29.51,6.4.02.59-.34.83-.86.92-2.66-1.02-5.29-2.09-6.72-4.82h0Z",
    style: {
      fill: "#dddada",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,283.98c-.02-5.88-.01-11.76-.06-17.64,0-.98.36-2.08-.59-2.89,1.75-1.23,3.62-2.21,5.68-2.8,2.38-.44,2.42,1.46,2.46,2.8.17,5.64.41,11.29-.12,16.93-1.79,2.55-4.13,3.99-7.36,3.6h0Z",
    style: {
      fill: "#cac8ca",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.8,284.39c1.19,5.73.25,11.53.58,17.28.07,1.33-1.18,1.26-1.71,1.93-2.44.76-4.9,1.32-7.46.57,1.69-4.8.64-9.77.93-14.66.09-1.56-.25-3.2.87-4.56,2.19-1.02,4.53-.33,6.79-.55h0Z",
    style: {
      fill: "#a9a7ad",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,246.46c1.66-1.64,3.64-2.8,5.68-3.88,1.16.49,1.32,1.55,1.35,2.59.16,6.03,0,12.06.11,18.09.01.67-.23,1.3-.59,1.85-1.05,1.83-2.93,2.57-4.65,3.48-.72.38-1.62.64-2.21-.37-1.1-5.31-.36-10.68-.51-16.02-.06-1.93-.48-3.98.82-5.74h.01Z",
    style: {
      fill: "#b5b3b8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.33,249.94c.61.53,1.22,1.06,1.83,1.6-.81,1.73-1.03,3.55-1.02,5.45.03,5.06.07,10.11,0,15.16-.49,1.11-1.39.77-2.12.47-1.96-.82-3.95-1.66-5.16-3.59-1.28-4.79-.45-9.66-.55-14.51-.03-1.58.07-3.17.15-4.76.07-1.35.41-2.71,2.36-2.14,1.5.77,3,1.54,4.51,2.3Z",
    style: {
      fill: "#e7e4e3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.14,270.77c.51.36.64.89.64,1.47,0,6.15.01,12.29.02,18.44-1.57,2.18-3.72,2.71-6.24,2.16-1.19-5.56-.31-11.19-.54-16.78-.06-1.28.06-2.54-1.79-2.43,2.5-1.32,5.13-2.28,7.91-2.86h0Z",
    style: {
      fill: "#dbd8d8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,257.21c1.89-1.5,3.97-2.66,6.27-3.43,1,.74,1.29,1.84,1.33,2.96.23,5.59.23,11.17,0,16.76-.02.56-.19,1.1-.45,1.6-1.49,2.25-3.98,2.91-6.27,3.86-.56.23-1.32.31-1.56-.6.87-5.93.29-11.89.44-17.83.03-1.11-.07-2.23.23-3.33h0Z",
    style: {
      fill: "#c2c0c3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4,265.28c.25-.49.76-1.01.72-1.48-.49-6.63.01-13.28-.25-19.92-.02-.44-.32-.87-.49-1.31,2.18-1.64,4.2-3.53,6.76-4.61-1.53,1.43-.51,3.16-.53,4.75-.05,6.2,0,12.4,0,18.6-1.2,2.69-3.46,3.73-6.22,3.96h0Z",
    style: {
      fill: "#b2afb5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,284.49c1.06.73,1.13,1.79,1.11,2.96-.04,4.58,0,9.16-.03,13.74-.01,1.17.05,2.23,1.16,2.92-1.69,1.33-3.16.81-4.53-.53-3.2-.37-3.53-2.48-3.44-5.19.16-4.85.05-9.7.05-14.55,1.95-.24,3.78.55,5.69.66h0Z",
    style: {
      fill: "#aba9af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,246.46c.02,7.41.04,14.82.06,22.23-.28,2.06-2.46,2.08-3.53,3.29-1.16.46-2.31,1.98-3.49.02.93-5.99.31-12.03.46-18.05.05-1.87.23-3.59,2-4.68.76-.55,1.52-1.1,2.28-1.66.77-.33,1.26-1.2,2.23-1.17h0Z",
    style: {
      fill: "#bab7bc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.01,284.95c0,5.39-.07,10.78.06,16.17.03,1.52-.45,2.43-1.75,3.03-1.69.54-3.39.44-5.08.06,0-5.25.12-10.51-.06-15.76-.07-1.94.6-2.9,2.29-3.41,1.52-.03,3.03-.06,4.55-.08h0Z",
    style: {
      fill: "#adabb1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.19,249.29c-.9,1.15-1.16,2.45-1.15,3.92.07,5.15-.02,10.3.05,15.46.02,1.47-.24,2.77-1.14,3.92-1.12,2-2.73,3.08-5.11,2.77.49-.84.61-1.76.57-2.72-.27-6.28.59-12.59-.59-18.85.77-1.53,3.3-1.22,3.51-3.35,1.69.96,2.44-1.18,3.85-1.15h0Z",
    style: {
      fill: "#bebbbf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.23,304.72c0-5.3,0-10.6,0-15.89,0-1.11-.08-2.24.55-3.24,3.03.18,6.1-.54,9.08.51-2.17,1-2.72,2.73-2.61,5,.15,3.07.1,6.16.02,9.23-.06,2.1.25,3.7,2.85,3.77.69.02,1.53.25,1.46,1.31-1.18.96-2.58.68-3.93.72-2.56-.03-5.17.28-7.41-1.41h-.01Z",
    style: {
      fill: "#bebbbf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.77,235.16c-1.31.57-1.22,1.73-1.22,2.86,0,5.69.05,11.38-.03,17.07-.02,1.33.51,2.32,1.15,3.35-2.84.06-4.87-1.2-5.62-3.49-1.2-1.57-.59-3.34-.59-5.05.02-5.26.01-10.54,0-15.8,0-1.14-.12-2.31,1.2-2.9.13,0,.26-.02.39-.03,1.57,1.33,3.14,2.65,4.72,3.98h0Z",
    style: {
      fill: "#d2cfd1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,305.23c-.24-.14-.48-.36-.73-.4-2.91-.4-4.37-2.07-4.37-5.01,0-3.39.14-6.79-.05-10.17-.14-2.64.63-3.99,3.46-3.56,1.5,0,3,.01,4.5.02-1.58,5.14-.61,10.42-.81,15.63-.06,1.54.8,2.19,2.28,2.17.84-.01,1.69,0,2.54.04,2.06-.02,4.12-.18,6.18.15.54.15,1.03.36,1.23.94-.1.16-.18.43-.31.46-4.66,1-9.31,1.5-13.92-.27h0Z",
    style: {
      fill: "#c5c2c5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,257.21c.72.51.63,1.29.63,2.03,0,5.5-.04,10.99.03,16.48.02,1.24-.61,2.1-1.16,3.05-.02,1.45-1.37,1.5-2.2,2.12-.76.29-1.53.79-2.34.1,0-5.65.02-11.29-.01-16.94,0-1.38.19-2.93-1.7-3.4,2.09-1.45,4.35-2.56,6.73-3.44h.01Z",
    style: {
      fill: "#c6c4c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4,284.91c2.6-.68,5.24-1.01,7.92-1.05-1.65,2.17-1.56,4.71-1.4,7.2.26,4.07-.88,8.25.97,12.2-1.27,1.86-3.19,1.01-4.86,1.18-3.59-.23-4.02-.63-4.07-4.2-.06-3.86-.05-7.71,0-11.56.02-1.42.04-2.86,1.44-3.76h0Z",
    style: {
      fill: "#e5e2e1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.92,303.14c-1.44.01-1.89-.72-1.87-2.12.06-4.87.17-9.74-.05-14.6-.09-1.99,1.45-1.82,2.32-2.56,1.3-.36,2.59-.74,3.96-.57,0,5.62,0,11.24.01,16.86,0,2.84,2.31,1.36,3.55,1.87-2.41,2.01-5.07,2.23-7.92,1.13h0Z",
    style: {
      fill: "#eceae8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.45,200.67c.08-.2.15-.41.23-.61,1.06-.92,2.13-1.84,3.19-2.76.59-.55,1.01-1.58,2-1.26,1.07.34,1.12,1.45,1.15,2.37.16,5.45.04,10.9.07,16.35.01,1.88-.06,3.76.36,5.61.45,1.37-.44,2.06-1.4,2.71-1.26.51-2.04,1.82-3.44,2.13-.33-.06-.62-.2-.87-.41-1.15-1.35-.85-3-.9-4.56-.2-6.53.41-13.06-.4-19.57h0Z",
    style: {
      fill: "#97959d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.92,240.37c0-7.2,0-14.41.05-21.61,0-.98-.64-2.37,1.06-2.76,1.74,1.28,3.31,2.74,4.58,4.51-1.09,1.31-1.15,2.87-1.15,4.46.02,6.43,0,12.86,0,19.29-2.39-.27-4.03-1.42-4.55-3.89h0Z",
    style: {
      fill: "#c1bfc2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.82,247.63c-1.11.09-1.72.67-1.72,1.8,0,5.95-.02,11.92.02,17.87,0,.63.34,1.25.52,1.88-2.21.21-3.77-.63-4.55-2.77-.66-1.14-1.15-2.26-1.13-3.68.09-5.56.03-11.12.05-16.68,0-.82-.24-1.72.55-2.37,2.2,1.14,4.4,2.27,6.27,3.94h0Z",
    style: {
      fill: "#e2dfdf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.25,221.07c-1.23-.7-1.02-1.88-1.02-3,0-6.47-.07-12.94.03-19.41.03-2.25-.51-2.78-2.39-1.36,1.32-2.6,3.63-4.3,5.68-6.24.98.8.61,1.91.61,2.89.03,6.67,0,13.33.02,20,0,1.18-.26,2.7,1.84,2.09-.27,2.44-2,4.25-4.78,5.03h0Z",
    style: {
      fill: "#9b99a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.08,709.56c-.03,1.94.24,3.89-.42,5.81-.23.66-.32,1.7.04,2.17,2.86,3.69,4.42,8.18,7.4,11.77.38.46.9.64,1.48.67-3.79,2.21-7.58,4.42-11.63,6.77-.75-2.7.06-4.95.35-7.18.85-6.68,1.39-13.41,2.78-20.02Z",
    style: {
      fill: "#4d4590",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.32,728.3c.77,0,1.43-.1,1.89-.87,2.57-4.26,5.17-8.51,7.76-12.75.75,5.25,1.5,10.49,2.24,15.74.2,1.46.34,2.93.59,5.12-4.5-2.61-8.5-4.93-12.5-7.24h0Z",
    style: {
      fill: "#4d458f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.83,272.64c-1.02-2.64-.42-5.39-.5-8.09-.1-3.47,0-6.94-.04-10.42-.02-1.37.24-2.44,1.86-2.6,1.26.58,2.52,1.16,3.78,1.75.4.38.8.75,1.2,1.13-1.21,2.87-.87,5.9-.9,8.88-.04,3.85.04,7.7.02,11.54-1.2,1.82-2.36.29-3.54-.05-.75-.61-1.81-.95-1.89-2.15h0Z",
    style: {
      fill: "#edeae8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.77,304.83c-.4-.06-.8-.11-1.2-.16-.67-.62-.85-1.45-.85-2.3,0-5.12-.3-10.26.16-15.38.09-.32.24-.62.46-.88,1.31-.72,2.84.16,4.15-.56,2.2-.94,4.52-.44,6.79-.58-.06,1.39-1.23,1.25-2.06,1.36-1.66.21-2.18,1.18-2.19,2.7-.01,3.94.06,7.87-.03,11.81-.05,1.95,1.33,2.48,2.58,3.26.18.34.14.64-.14.92-2.58.89-5.15,1.1-7.67-.18h0Z",
    style: {
      fill: "#d8d5d6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.94,275.41c-1.01-2.15-.48-4.44-.53-6.66-.08-3.75-.04-7.5-.02-11.25.01-1.32,0-2.7,1.74-3.08,1.91.57,3.49,1.71,5.11,2.82-1.88.18-1.76,1.56-1.76,2.89,0,5.86-.02,11.72-.02,17.58-2.05.32-3.62-.33-4.51-2.3h0Z",
    style: {
      fill: "#f1eeec",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,304.76c-3.77.01-5.66-1.83-5.66-5.52,0-3.36.11-6.72-.05-10.07-.07-1.54.5-2.41,1.74-3.07,3.39-.14,6.76-.87,10.18-.46.18.1.24.2.18.3-.06.1-.12.15-.18.15h-.01c-.59.53-1.29.83-2.05.81-2.83-.06-3.38,1.61-3.32,4.01.09,3.46.04,6.93.01,10.39-.01,1.22.04,2.45-.85,3.46h0Z",
    style: {
      fill: "#cbc8ca",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.68,304.24c-2.8.41-3.77-.68-3.55-3.57.27-3.73.21-7.49.02-11.23-.14-2.75.43-4.43,3.63-3.92.56.09,1.13-.03,1.5-.55.37-.02.75-.04,1.12-.06-1.08,2.7-.4,5.52-.53,8.28-.11,2.23.14,4.48-.06,6.7-.25,2.75.46,4.3,3.55,3.79-1.7,2.18-3.68,1.42-5.67.55h0Z",
    style: {
      fill: "#dfdcdc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.7,449.51c-4.27,1.63-6.49,5.81-10.16,8.19-.62.4-1.14.95-1.71,1.43,0-2.64.01-5.28.02-7.92,3.98-2.46,6.86-6.19,10.45-9.1,1.15-.94,2.1-2.13,3.76-2.15-1.63,2.98-2.64,6.11-2.35,9.57h0Z",
    style: {
      fill: "#5271a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,668.91l10.74.02c1.52,3.08.98,6.27.46,9.44-.08.49-.49.76-1.03.72-.24.02-.48.05-.71.06-.53-.39-1.05-.78-1.57-1.17-2.32-3.3-5.92-5.49-7.89-9.09h0Z",
    style: {
      fill: "#d5d3d4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.58,559.68c-1.11.84-.7,2.06-.7,3.13-.03,9.73-.01,19.47-.01,29.2,0,.94,0,1.89-.01,2.83h-.51c-.03-11.29-.08-22.58-.1-33.87,0-.76-.38-2.17,1.32-1.28h0Z",
    style: {
      fill: "#323573",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.82,493.62v11.3c-1.23-1.49-.49-3.23-.54-4.85-.1-3.28.02-6.56.05-9.85h.48c0,1.13,0,2.26.01,3.39h0Z",
    style: {
      fill: "#5373a3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.57,269.14c-1.54-.02-2.79-.68-3.9-1.69.55.02,1.1.04,1.65.06.75.54,1.5,1.09,2.25,1.63h0Z",
    style: {
      fill: "#e4e1e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.29,685.37c1.3.08,2.45.4,2.95,1.79-1.07-.46-2.14-.91-2.95-1.79Z",
    style: {
      fill: "#313572",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.52,439.87c.17-1.3.91-2.04,2.21-2.23-.49.98-1.23,1.72-2.21,2.23Z",
    style: {
      fill: "#5373a3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,286.1v-.45c1.32-.03,2.64-.06,3.95-.1-1.19,1.06-2.64.34-3.95.55Z",
    style: {
      fill: "#d2cfd1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34,437.07c.19-.37.37-.75.57-1.12h1.69c-.61.66-1.33,1.07-2.25,1.13h0Z",
    style: {
      fill: "#5373a3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.43,69.3c2.18-5.89,4.37-11.77,6.55-17.66,1.08-2.91,2.18-5.81,3.27-8.71.16-.44.19-1.08.51-1.3,3.06-2.05,6.48-.75,9.71-.74,1.82,0,1.06,2.11,1.05,3.27-.15,12.42-.41,24.84-.55,37.26-.02,1.76-.63,2.19-2.31,2.21-6.06.07-6.11.13-6.05-5.98.08-6.96.27-13.92.4-20.88.02-1.08,0-2.16-.62-3.35-.85,2.22-1.7,4.44-2.53,6.67-2.27,6.08-4.58,12.15-6.75,18.27-.57,1.59-1.39,2.13-3.07,2.12-5.04-.03-5.03.03-6.56-4.7-2.02-6.27-4.04-12.54-6.11-18.79-.4-1.19-1.01-2.31-1.52-3.47-.3.01-.6.03-.9.04,0,6.6,0,13.2,0,19.8,0,2.54-.13,5.08-.04,7.62.06,1.58-.46,2.3-2.08,2.09-.46-.06-.94,0-1.41-.01-3.87-.09-3.82-.09-3.74-3.96.25-11.95.54-23.9.59-35.85.01-2.69.81-3.61,3.36-3.09.18.04.37.01.57.02,8.25.15,8.22.16,10.69,7.95,2.25,7.07,4.57,14.13,6.86,21.19.22,0,.45-.01.67-.02h-.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.2,238.56c-7.39,1.4-14.81,2.71-22.17,4.24-1.89.39-2.88.05-3.83-1.67-2.26-4.05-2.35-3.99.67-7.55,4.94-5.81,9.87-11.63,14.8-17.45.32-.88.06-1.18-.84-.84-7.48,4.38-14.98,8.7-22.41,13.17-1.59.96-2.41,1.11-3.47-.72-2.32-4.03-2.43-3.98,1.55-6.33,10.22-6.03,20.46-12.02,30.63-18.14,1.79-1.08,2.74-1.01,3.69.93.99,2.02,2.18,3.97,3.46,5.82,1.05,1.52.81,2.6-.36,3.95-5.88,6.75-11.67,13.57-17.49,20.37-.36.41-.69.84-1.54,1.88,5.55-1.08,10.37-2.01,15.2-2.96,4.71-.92,9.43-1.83,14.13-2.77.84-.16,1.71-.47,2.28.46,1.42,2.34,2.83,4.67,4.18,7.04.85,1.5-.65,1.75-1.41,2.21-7.28,4.35-14.58,8.64-21.89,12.94-3.65,2.15-7.34,4.25-10.94,6.48-1.35.84-2.08,1-3.05-.62-3.18-5.27-3.26-5.22,2.01-8.35,6.39-3.8,12.78-7.61,19.17-11.41.18-.33.43-.61.7-.83-.29-.37-.65,0-.96-.1-.72.04-1.46-.18-2.14.23v.02Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.01,346.68c-9.69-.02-16.48-5.1-19.13-14.44-1.58-5.61-2.77-11.33-4.2-16.99-.38-1.52-.32-2.3,1.55-2.74,12.56-2.91,25.09-5.92,37.61-8.99,1.55-.38,2.19-.09,2.54,1.45,1.4,6.15,3.07,12.24,4.27,18.42,2.04,10.51-2.77,18.38-12.95,21.64-3.24,1.04-6.54,1.78-9.7,1.63h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.05,256.55c11.69.02,20.86,10.22,20.82,23.16-.04,11.67-11.23,21.32-24.7,21.29-11.51-.02-20.83-10.26-20.9-22.95-.06-11.82,11.11-21.52,24.77-21.5h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.74,310.54c1.43-1.71,2.53-3.23,3.84-4.55,3.52-3.56,7.58-4.33,12.14-2.44,4.04,1.67,6.02,4.86,5.79,9.99-.3,6.84-3.12,13.13-4.64,19.71-.25,1.08-.98.87-1.76.66-12.7-3.46-25.4-6.92-38.11-10.31-1.57-.42-1.62-1.22-1.27-2.47,1.36-4.79,2.54-9.64,4.08-14.37,2.3-7.09,7.19-9.86,12.97-7.69,3.18,1.19,5,3.57,5.95,6.69.43,1.41.62,2.9,1.01,4.78h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.04,236.88c-1.74,3.25-3.22,6.05-4.72,8.83-.55,1.03-1.59.87-2.5.92-5.35.33-10.7.85-16.05.87-2.92.01-3.26,2.08-4.09,3.83-.48,1.01.72,1.14,1.3,1.45,3.88,2.12,7.76,4.24,11.7,6.25,1.43.73,1.91,1.36,1.06,3-2.94,5.68-2.88,5.73-8.51,2.73-10.04-5.35-20.06-10.76-30.14-16.05-1.65-.87-2.22-1.54-1.18-3.36,2.43-4.24,4.57-8.65,6.97-12.91,3.15-5.58,6.99-7.87,11.39-7.02,5.49,1.05,9.63,5.3,10.39,11.2.33,2.6.96,3.27,3.75,2.8,6.65-1.11,13.39-1.69,20.64-2.55h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,112.32c-3.23,1.75-5.95,3.19-8.63,4.72-1.16.66-1.97,0-2.84-.51-4.71-2.76-9.48-5.42-14.08-8.35-2.34-1.49-3.72.2-5.3,1.11-.89.51.02,1.35.33,1.95,2.08,3.9,4.14,7.81,6.33,11.66.84,1.47.66,2.18-.88,3.04-5.57,3.15-5.5,3.2-8.52-2.4-5.4-10.02-10.78-20.05-16.29-30.01-.99-1.8-.92-2.66,1.03-3.61,4.13-2.03,8.14-4.32,12.2-6.5.33-.18.67-.34,1.01-.5,5.52-2.59,10.01-2.3,13.13.85,3.72,3.74,4.98,9.77,2.37,14.61-1.56,2.88-.62,3.72,1.84,4.86,5.95,2.79,11.78,5.85,18.28,9.1h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.63,138c-2.52-1.49-5.06-3.04-7.66-4.51-1.06-.6-.95-1.54-.97-2.45-.11-5.55-.33-11.11-.25-16.67.05-2.74-2.04-3.15-3.68-3.98-1.05-.53-1.31.8-1.7,1.45-2.19,3.62-4.4,7.25-6.47,10.95-.89,1.61-1.58,2.08-3.39.96-5.13-3.16-5.17-3.05-2.04-8.32,5.79-9.71,11.58-19.41,17.26-29.19,1.1-1.88,1.95-2.27,3.87-.99,3.45,2.29,7.1,4.28,10.66,6.4.65.38,1.3.76,1.93,1.18,5.08,3.39,7.11,7.37,5.98,11.72-1.37,5.28-6.31,9.4-11.99,9.53-2.38.06-2.81.81-2.62,2.95.57,6.28.96,12.58,1.43,18.88.05.62.38,1.27-.36,2.09h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.87,112.68c-5.47-.35-10.99-2.72-15.25-7.53-3.39-3.82-4.26-8.4-2.53-13.2,3.33-9.21,7.65-18.01,11.42-27.04.41-.98.89-1.16,1.94-.86,7.17,2.05,7.35,2.4,4.41,9.1-2.65,6.03-5.28,12.07-7.87,18.12-.55,1.29-1,2.64-1.35,4-1.42,5.58.71,9.13,6.26,10.65,2.74.75,5.01.07,6.9-2,1.55-1.69,2.58-3.69,3.48-5.78,3.21-7.43,6.48-14.83,9.6-22.3.73-1.74,1.45-1.95,3.13-1.2,5.07,2.28,5.11,2.21,2.86,7.42-2.76,6.39-5.5,12.8-8.31,19.17-.84,1.89-1.78,3.75-2.88,5.49-2.54,4.03-6.11,5.91-11.81,5.95h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.72,131.26c.1,2.23-.39,4.34-1.54,6.22-3.67,5.96-9.03,9.56-15.93,10.54-4.49.63-8.36-1.01-11.33-4.48-5.1-5.95-9.24-12.6-13.91-18.87-.23-.3-.43-.62-.64-.93-3.87-5.53-3.83-5.46,1.69-9.37,1.48-1.05,2.08-.75,3.03.61,4.53,6.48,9.16,12.9,13.78,19.32,1.37,1.91,2.8,3.79,4.78,5.15,3.11,2.13,6.29,1.92,9.61-.65,3.07-2.38,3.9-5.15,2.62-8.74-.77-2.15-2.09-3.99-3.41-5.83-4.5-6.28-8.92-12.61-13.51-18.82-1.2-1.62-.97-2.44.61-3.55,4.26-2.99,4.22-3.05,7.25,1.18,4.44,6.2,8.9,12.39,13.28,18.64,2.01,2.87,3.82,5.86,3.64,9.59h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.26,89.24c.3,1.24-.48,1.18-1.3,1.05-2.05-.32-4.08-.7-6.14-.96-1.3-.16-1.68-.96-1.91-2.06-.55-2.67-1.27-5.32-1.7-8.01-.28-1.73-1.11-2.29-2.77-2.51-4.29-.56-8.57-1.27-12.83-2.02-1.59-.28-2.61.02-3.39,1.58-1.22,2.44-2.68,4.76-4.08,7.1-.79,1.33-5.98,1.71-6.79.48-.59-.9.28-1.59.68-2.27,5.55-9.63,11.14-19.24,16.71-28.85.99-1.71,2.23-3.33,2.92-5.16,1.17-3.11,3.13-3.53,6.13-2.89,4.76,1.03,4.79.86,5.85,5.67,2.75,12.4,5.5,24.81,8.25,37.21.12.55.24,1.1.36,1.65h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.11,385.82c-1.88.68-2.4-.24-2.58-2.19-.76-7.87-1.62-15.72-2.58-23.56-.2-1.62.16-2.09,1.78-2.26,12.91-1.38,25.8-2.85,38.7-4.32,1.3-.15,2.08-.06,2.23,1.58.74,7.67,1.5,15.35,2.48,23.01.38,2.99-1.83,1.98-3.05,2.3-1.26.32-2.74.77-2.92-1.62-.34-4.59-1.05-9.16-1.48-13.74-.15-1.58-.71-2.15-2.3-1.91-2.6.4-5.21.76-7.84.94-1.58.11-1.84.8-1.67,2.17.42,3.46.59,6.94,1.18,10.37.55,3.28-1.97,2.18-3.38,2.62-1.92.61-2.38-.44-2.49-2.19-.24-3.38-.76-6.73-1.06-10.1-.12-1.45-.68-1.97-2.14-1.78-2.98.4-5.97.81-8.97.99-1.91.12-2.05,1.04-1.86,2.58.54,4.29.97,8.6,1.48,12.89.44,3.77.46,3.77-3.52,4.18v.02Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,299.09c-.51-.19-1.04-.38-1.56-.59-11.72-4.61-23.43-9.28-35.19-13.81-2-.77-2.24-1.53-1.43-3.48,2.8-6.67,5.52-13.39,7.95-20.21,1.13-3.15,2.69-1.39,4.32-.98,1.98.5,2.18,1.45,1.41,3.25-1.75,4.05-3.26,8.22-4.95,12.3-.59,1.44-.38,2.18,1.17,2.7,2.4.81,4.79,1.71,7.08,2.8,1.72.81,2.28.13,2.82-1.36,1.11-3.09,2.56-6.08,3.51-9.23.89-2.96,2.46-1.52,4.08-1.06,1.79.51,2.44,1.2,1.53,3.14-1.39,2.98-2.31,6.17-3.7,9.15-.91,1.95-.21,2.61,1.52,3.2,2.4.81,4.8,1.7,7.07,2.8,1.97.96,2.96.68,3.73-1.49,1.53-4.34,3.51-8.53,4.94-12.91,1-3.02,2.6-1.68,4.33-1.18,2.01.58,2.38,1.5,1.56,3.49-2.97,7.22-5.75,14.51-8.63,21.77-.28.72-.33,1.76-1.56,1.69h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65,206.03c-.59-.45-1.13-.81-1.62-1.23-9.68-8.25-19.34-16.52-29.06-24.72-1.39-1.17-1.57-1.93-.32-3.36,4.9-5.6,9.77-11.24,14.45-17.02,1.63-2.01,2.48-.66,3.55.3,1.07.96,2.92,1.56.97,3.62-3.03,3.22-5.69,6.78-8.67,10.05-1.39,1.53-1.16,2.38.38,3.53,1.96,1.46,3.79,3.11,5.58,4.78,1.15,1.07,1.9,1.07,2.92-.23,2.16-2.73,4.6-5.25,6.7-8.02,1.52-2.01,2.46-.72,3.59.24,1.11.96,2.62,1.68.89,3.52-2.32,2.47-4.31,5.25-6.67,7.67-1.52,1.56-1.08,2.35.37,3.48,2.23,1.73,4.41,3.55,6.46,5.49,1.3,1.23,2.08,1.06,3.16-.25,3.11-3.78,6.45-7.39,9.46-11.24,1.64-2.09,2.63-.8,3.82.24,1.14,1,2.74,1.68.93,3.72-5.31,5.99-10.42,12.15-15.63,18.24-.36.42-.8.76-1.26,1.19h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.16,392.92c.07-3.77.58-7.48,1.26-11.2.4-2.19,1.24-3,3.53-2.77,4.09.42,4.07.29,2.92,4.15-.93,3.16-1.79,6.33-1.76,9.67.05,6.55,3.41,11.08,9.66,12.97,3.58,1.08,7.26,1.22,10.9.66,7.62-1.18,12.02-6.49,12.15-14.27.06-3.63-.55-7.15-1.97-10.46-.85-1.99-.37-2.32,1.64-2.23,4.48.2,4.54.08,5.53,4.4,1.4,6.14,1.66,12.33-.14,18.42-1.88,6.4-5.99,11.02-12.48,12.7-9.4,2.44-18.59,2.29-26-5.27-4.54-4.63-5.33-10.6-5.24-16.77h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.84,151.25c.31.1.42.11.48.17,4.98,5.13,4.78,3.54,1.18,9.36-2.35,3.78-5.54,6.9-9.13,9.54-9.14,6.69-19.84,5.46-27.94-3.18-1.03-1.1-2.03-2.23-2.93-3.44-6.93-9.29-6.14-19.05,2.26-27.77,3.22-3.34,6.94-6.06,10.84-8.57,1.33-.86,2.33-.99,3.36.37.62.83,1.35,1.58,2.11,2.27,1.19,1.09.71,1.61-.5,2.17-3.87,1.78-7.57,3.82-10.57,6.92-4.04,4.17-4.98,9.01-2.72,14.3,2.06,4.81,5.49,8.57,10.11,11.06,5.28,2.84,10.34,2.19,15.04-1.48,3.95-3.09,6.5-7.22,8.43-11.72h-.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.23,230.45c1.98-1.62,3.83-3.05,5.59-4.58,1.79-1.56,3.3-3.36,4.3-5.54,1.06-2.31,1.22-4.6-.65-6.57-1.82-1.91-4.11-2.27-6.5-1.28-2.7,1.11-5.32,2.39-7.97,3.61-2.23,1.03-4.5,1.89-6.94,2.3-7.75,1.28-14.31-5.21-12.92-12.91,1.16-6.41,5.51-10.8,9.96-15.04,1.5-1.43,2.53.46,3.59,1.13,2.83,1.79,2.79,1.85.15,3.94-2,1.58-3.96,3.21-5.34,5.4-1.37,2.17-2.22,4.55-.51,6.85,1.79,2.42,4.24,1.89,6.66.94,4.03-1.59,7.75-3.82,11.85-5.3,5.19-1.87,9.69-.93,13.49,2.9,3.68,3.72,3.77,8.3,2.22,12.92-1.94,5.79-6.02,10.15-10.23,14.37-.76.76-1.45.64-2.24.06-1.44-1.05-2.9-2.06-4.5-3.2h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.12,61.18c-.15,3.74-1.39,4.69-4.93,3.68-2.99-.85-6.01-1.62-8.93-2.65-1.79-.63-2.41-.11-2.9,1.61-2.84,10.15-5.83,20.26-8.64,30.42-.61,2.19-1.36,2.76-3.67,2.04-5.96-1.87-5.98-1.73-4.25-7.61,2.65-9.03,5.22-18.08,7.91-27.09.53-1.79.33-2.69-1.67-3.17-3.56-.87-7.04-2.06-10.59-3-2.8-.74-1.11-2.4-.83-3.71.27-1.28.18-2.83,2.55-2.12,11.45,3.42,22.95,6.66,34.43,9.98.77.22,1.77.34,1.51,1.63h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,65.49c-3.14,1.02-6.45,2.09-9.76,3.17-3.59,1.18-4.69.39-5.14-3.48-.19-1.69,1.16-1.53,1.99-1.8,9.83-3.23,19.7-6.41,29.55-9.59.81-.26,1.62-.51,2.43-.77,3.36-1.07,4.88.07,4.98,3.61.03,1.22-.76,1.35-1.56,1.61-3.49,1.13-6.96,2.36-10.5,3.34-1.83.51-2.04,1.27-1.48,2.97,3.33,10.1,6.5,20.26,9.87,30.35.64,1.93.48,2.73-1.58,3.37-6.31,1.97-6.27,2.05-8.32-4.34-2.82-8.78-5.66-17.56-8.53-26.32-.29-.88-.23-2.21-1.96-2.11h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.2,50.42c3.21-.65,5.88-1.17,8.54-1.74,1.41-.3,2.03.71,2.75,1.56,3.27,3.77,6.51,7.56,9.78,11.33.66.76,1.39,1.48,2.29,2.44,1.98-5.32,3.85-10.33,5.72-15.34,1.76-4.71,2.63-5.25,8.39-5.01-2.11,5.8-3.81,11.69-6.37,17.18-3.07,6.57-3.72,13-1.46,19.84.55,1.68.59,3.53,1.06,5.25.49,1.78-.28,2.28-1.85,2.62-6.76,1.49-7.14,1.57-7.88-5.26-.83-7.62-3.59-13.92-9.16-19.3-4.16-4.03-7.66-8.74-11.81-13.57h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,333.11c4.99,4.11,10.24,7.84,14.77,12.3,4.94,4.87,10.69,6.97,17.37,7.41,2.06.14,4.09.63,6.14.88,1.21.15,1.67.7,1.31,1.88-.03.09-.05.18-.06.28-.99,6.92-1.09,7.36-7.99,5.85-7.63-1.67-14.56-.85-21.48,2.65-4.43,2.24-9.26,3.68-13.88,5.58-1.64.67-2.1.58-1.87-1.41.89-7.48.83-7.49,7.79-10.25,4.01-1.59,8.02-3.19,12.55-4.99-2.51-2.08-4.71-3.91-6.9-5.73-1.82-1.5-3.63-3-5.45-4.5-4.33-3.55-4.45-4.03-2.3-9.95h.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.39,165.35c-.45-.02-6.12-4.96-6.16-5.37-.09-1,.77-1.44,1.3-2.05,6.97-8.04,13.92-16.09,20.98-24.05,1.27-1.43,1.17-2.18-.24-3.33-2.84-2.32-5.5-4.86-8.34-7.19-2.25-1.84-.03-2.68.75-3.78.82-1.14,1.5-2.21,3.26-.64,8.7,7.78,17.5,15.46,26.4,23,2.15,1.82.74,2.69-.27,4.03-1.18,1.58-2.14,2.02-3.78.41-2.41-2.38-5.15-4.42-7.58-6.77-1.52-1.46-2.36-1.38-3.75.25-6.83,8.03-13.8,15.95-20.73,23.89-.54.62-.94,1.44-1.83,1.59h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.29,147.54c2.09,2.27,3.89,4.3,5.75,6.26,1,1.06.47,2.09.12,3.15-1.66,5.11-3.26,10.22-5.01,15.3-.63,1.82-.4,2.35,1.62,1.93,4.51-.96,9.05-1.76,13.58-2.64,5.28-1.02,5.92-.72,9.04,4.41-5.62,1.09-11.1,2.58-16.67,3.13-8.1.79-14.52,4.12-20.06,10.03-4.26,4.55-4.49,4.2-8.78-.32-1.53-1.61-1.54-2.52.21-3.87,2.08-1.61,3.79-3.7,5.94-5.21,4.41-3.12,6.53-7.46,7.95-12.5,1.83-6.51,4.11-12.89,6.31-19.66h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.86,396.87c.03,3.61.03,3.57-3.7,3.62-10.08.15-20.15.42-30.23.46-2.34.01-2.78.76-2.68,2.94.21,4.61-.11,9.25.21,13.84.25,3.56-2.28,2.36-3.88,2.7-2.22.48-2.4-1.02-2.4-2.7-.03-6.79-.12-13.57-.16-20.35-.03-5.42-.02-5.37,5.5-5.44,11.02-.14,22.04-.39,33.05-.48,4.84-.04,3.64-.77,4.29,3.99.06.46,0,.94,0,1.41h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7,67.98c.97-.1,1.07.68,1.32,1.24,5.17,12.09,10.33,24.19,15.52,36.26.51,1.19.36,1.76-.85,2.39-6.63,3.42-6.58,3.44-9.43-3.3-4.39-10.38-8.79-20.76-13.32-31.08-.81-1.85-.51-2.64,1.34-3.26,1.87-.62,3.64-1.5,5.42-2.25h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.76,146.5c-1.94-1.49-4.09-3.01-6.07-4.72-.54-.47.28-1.19.64-1.69,7.56-10.46,15.16-20.88,22.68-31.36.93-1.3,1.54-1.45,2.88-.5,5.58,3.95,5.63,3.91,1.63,9.44-6.56,9.09-13.14,18.16-19.73,27.22-.46.64-.74,1.57-2.05,1.6h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M795.15,238.51c-.52.25-1.04.49-1.56.74-.59-.96-1.6-.45-2.4-.7.64-.59,1.47-.49,2.24-.6.63-.01,1.52-.8,1.71.55h0Z",
    style: {
      fill: "#7c78b7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.83,215.29c.51-.7,1.22-1.07,2.24-1.31.04,1.13-.67,1.65-1.4,2.15-.28-.28-.56-.56-.84-.84h0Z",
    style: {
      fill: "#8784be",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.75,578.01v30.23c0,7.26-.14,14.51.07,21.76.08,2.73-.87,3.39-3.36,3.21-2.62-.19-5.28-.18-7.91,0-2.18.15-2.68-.67-2.67-2.74.07-18.66.04-37.31.04-55.96,0-10.93.09-21.86-.07-32.79-.04-2.59.77-3.26,3.19-3.07,2.53.2,5.1.19,7.62,0,2-.15,2.74.68,3.37,2.45,5.97,16.86,12.03,33.68,18.1,50.51.27.76.31,1.68,1.53,2.54v-3.14c0-16.49.03-32.98-.05-49.47-.01-2.14.44-3.07,2.78-2.9,2.81.21,5.66.18,8.47,0,2.08-.13,2.47.67,2.46,2.58-.06,19.41-.04,38.82-.04,58.23,0,10.37-.06,20.73.05,31.09.02,2.13-.56,2.82-2.68,2.66-2.53-.18-5.1-.2-7.62,0-2.1.16-2.92-.71-3.6-2.59-6.14-17.1-12.38-34.16-18.59-51.24-.18-.5-.39-1-.58-1.49-.18.04-.36.08-.54.12h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18,585.73c0-14.79.04-29.59-.05-44.38-.01-2.1.53-2.75,2.67-2.7,6.59.14,13.19.04,19.79.05,12.73.02,20.04,5.97,22.51,18.5,1.29,6.54,1.19,13.11-.43,19.61-1.24,4.95-3.81,9.05-8.17,11.77-1.79,1.12-2.05,2.13-1.37,4.09,4.35,12.54,8.53,25.14,12.85,37.68.74,2.13.68,3.03-1.94,2.86-3.1-.2-6.22-.17-9.33,0-1.88.1-2.62-.68-3.13-2.36-3.53-11.52-7.27-22.98-10.64-34.54-.81-2.79-1.92-3.76-4.8-3.6-4.97.28-4.3-.45-4.31,4.47-.03,11.12-.07,22.24.04,33.35.02,2.17-.64,2.79-2.73,2.66-2.72-.16-5.47-.19-8.19,0-2.25.16-2.85-.58-2.83-2.82.1-14.88.05-29.77.05-44.66h.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.42,586.02c0,8.66.07,17.33-.02,25.99-.12,11.43-8.45,20.56-19.74,21.79-12.09,1.32-22.59-5.77-25.1-17.03-.34-1.54-.48-3.17-.48-4.76-.03-17.42-.08-34.84,0-52.26.06-11.75,8.16-20.4,20.22-21.87,11.09-1.35,21.46,5.59,24.29,16.3.55,2.09.84,4.23.83,6.42-.03,8.48-.01,16.95-.01,25.43h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.58,633.17c-6.62,0-6.64,0-7.99-6.51-.8-3.87-1.56-7.75-2.22-11.64-.27-1.58-.86-2.21-2.55-2.17-4.71.11-9.42.12-14.13,0-1.74-.05-2.23.68-2.51,2.21-.95,5.18-2.14,10.32-2.99,15.51-.36,2.15-1.26,2.78-3.33,2.65-2.82-.17-5.66-.19-8.47,0-2.51.16-2.22-1.11-1.85-2.75,2.43-10.74,4.82-21.48,7.22-32.23,4.2-18.83,8.42-37.65,12.53-56.49.5-2.32,1.35-3.39,3.85-3.08,2.69.33,6.03-1.03,7.97.51,1.91,1.54,1.62,5.01,2.21,7.65,6.25,27.82,12.41,55.65,18.7,83.45.57,2.49-.06,3.21-2.48,2.92-1.3-.16-2.64-.03-3.95-.03h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,585.75c0-14.79.04-29.58-.05-44.36-.01-2.05.46-2.76,2.65-2.74,11.77.11,23.55.08,35.32.01,1.91-.01,2.71.46,2.6,2.51-.16,2.63-.15,5.28,0,7.91.11,1.95-.7,2.36-2.47,2.35-7.06-.08-14.13.05-21.19-.08-2.24-.04-3.13.42-3.08,2.9.16,7.44.12,14.88.02,22.32-.03,2.02.64,2.54,2.57,2.51,6.03-.11,12.06.04,18.09-.08,2.02-.04,2.91.38,2.74,2.61-.2,2.71-.15,5.46-.01,8.19.09,1.79-.59,2.23-2.27,2.21-6.22-.08-12.44.02-18.65-.07-1.79-.03-2.48.42-2.45,2.35.1,7.72.08,15.44,0,23.17-.02,1.78.61,2.23,2.29,2.21,7.25-.07,14.51.05,21.76-.08,2.14-.04,2.8.59,2.68,2.7-.18,2.91-.1,5.84-.02,8.75.04,1.54-.42,2.18-2.08,2.18-12.15-.05-24.3-.07-36.45,0-2.32.02-1.97-1.42-1.97-2.81v-44.65h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,585.77c0-8.77-.02-17.53,0-26.29.02-12.09,8.29-20.83,20.43-21.66,11.9-.81,21.41,6.8,23.1,18.52.91,6.31-1.8,9.47-8.13,9.47h-.28c-3.07,0-4.71-1.56-4.9-4.68-.41-6.53-4.18-10.3-9.63-9.64-3.11.37-5.23,1.89-6.1,5.03-.55,2.01-.88,4.03-.88,6.12.01,15.83,0,31.66.02,47.49,0,1.31.12,2.64.41,3.91.97,4.36,3.46,6.34,7.74,6.27,4.21-.06,7.31-2.47,8.06-6.5.34-1.84.35-3.75.36-5.63,0-1.37.33-2.09,1.89-2.06,3.39.08,6.79.03,10.17.02.95,0,1.49.19,1.68,1.35,1.88,11.71-5.82,23.84-17.23,25.95-16.25,3.01-26.87-7.26-26.75-21.09.07-8.86.01-17.71.01-26.57h.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.74,585.78c0-8.76-.02-17.52,0-26.27.03-12.53,8.52-21.23,21.16-21.74,12-.48,21.6,8.12,22.5,20.22.14,1.87.01,3.77.12,5.64.09,1.54-.42,2.23-2.06,2.19-3.2-.08-6.41-.08-9.6,0-1.68.05-2.09-.71-2.02-2.22.13-2.64.07-5.27-1.24-7.71-1.77-3.29-4.77-4.89-8.41-4.41-3.76.5-5.38,2.04-6.33,6.14-.29,1.27-.46,2.6-.47,3.91-.03,16.58-.06,33.15,0,49.73.03,7.25,5.02,10.88,11.37,8.38,3.75-1.48,5-4.59,5.1-8.35.09-3.44,1.83-5.16,5.21-5.16,2.26,0,4.52.02,6.78,0,.97,0,1.56.21,1.67,1.37,1.28,13.15-5.37,22.43-15.25,25.41-13.21,3.99-28.55-2.97-28.53-20.3.01-8.95,0-17.89,0-26.84h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.48,538.7c5.84,0,11.69.06,17.53-.03,1.8-.03,2.54.46,2.43,2.36-.15,2.63-.16,5.28,0,7.91.13,2.09-.75,2.5-2.63,2.48-7.07-.09-14.14.03-21.2-.07-2.08-.03-3,.32-2.95,2.74.17,7.72.16,15.46,0,23.18-.05,2.39.85,2.8,2.95,2.77,6.03-.11,12.06.03,18.09-.08,1.89-.03,2.44.61,2.35,2.42-.13,2.73-.12,5.47,0,8.19.08,1.74-.54,2.27-2.26,2.25-6.03-.08-12.06.06-18.09-.08-2.31-.06-3.07.56-3.04,2.97.12,11.59,0,23.18.1,34.77.02,2.05-.43,2.89-2.64,2.74-2.91-.19-5.84-.12-8.76-.02-1.65.06-2.33-.36-2.32-2.18.05-30.06.05-60.13,0-90.18,0-1.84.73-2.18,2.34-2.16,6.03.07,12.06.03,18.09.03h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.68,592.26c0,12.72-.06,25.43.05,38.14.02,2.25-.59,2.97-2.83,2.8-2.53-.19-5.1-.2-7.62,0-2.52.2-3.36-.51-3.34-3.21.12-18.18.07-36.36.07-54.53,0-6.97-.14-13.95.07-20.91.08-2.73-.87-3.37-3.37-3.22-3.38.19-6.78-.02-10.17.08-1.65.05-2.39-.36-2.3-2.18.14-2.91.08-5.84.02-8.76-.03-1.33.43-1.8,1.78-1.8,13.75.03,27.5.04,41.25,0,1.52,0,1.94.58,1.91,2-.07,2.82-.1,5.66.01,8.48.07,1.71-.5,2.32-2.25,2.27-3.39-.11-6.79.12-10.17-.08-2.43-.15-3.2.48-3.17,3.07.15,12.62.07,25.24.07,37.86h-.01Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,592.58c0,12.62-.06,25.24.06,37.86.02,2.32-.71,2.9-2.87,2.77-3-.17-6.03-.08-9.04-.03-1.32.03-1.88-.45-1.83-1.8.07-1.88.02-3.77.02-5.65,0-23.73-.03-47.47.05-71.2.01-2.41-.51-3.37-3.1-3.2-3.56.23-7.15,0-10.73.08-1.44.03-2.02-.42-1.98-1.92.09-3.01.08-6.03,0-9.04-.03-1.37.51-1.76,1.82-1.76,13.75.03,27.5.03,41.25,0,1.27,0,1.89.34,1.86,1.74-.07,3.01-.07,6.03,0,9.04.04,1.49-.53,1.97-1.98,1.94-3.58-.07-7.17.11-10.73-.07-2.22-.11-2.86.56-2.84,2.81.11,12.81.05,25.62.05,38.43h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,585.79c0-14.78.05-29.57-.06-44.35-.02-2.28.68-2.92,2.86-2.78,2.62.18,5.28.19,7.91,0,2.31-.17,3.04.53,3.02,2.94-.11,15.25-.06,30.51-.06,45.76,0,14.22-.07,28.44.07,42.65.03,2.69-.81,3.42-3.34,3.21s-5.09-.19-7.62,0c-2.22.16-2.85-.54-2.83-2.79.1-14.88.05-29.75.05-44.63h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.94,586.09c0,14.6-.07,29.19.07,43.78.03,2.79-.81,3.57-3.48,3.35-2.8-.24-5.64-.1-8.47-.03-1.33.03-1.91-.44-1.8-1.79.07-.93.01-1.88.01-2.82,0-28.91.04-57.81-.07-86.72-.01-2.69.79-3.4,3.3-3.2,2.53.2,5.09.18,7.62,0,2.19-.15,2.88.52,2.87,2.8-.1,14.88-.05,29.75-.05,44.63h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.09,586.09c0,14.69-.07,29.37.06,44.05.02,2.57-.76,3.26-3.19,3.07-2.62-.2-5.28-.18-7.9,0-2.13.14-2.71-.58-2.7-2.7.08-17.98.05-35.96.05-53.94,0-11.58.1-23.16-.07-34.73-.04-2.73.86-3.38,3.34-3.18,2.53.19,5.09.18,7.62,0,2.22-.16,2.86.57,2.84,2.82-.1,14.87-.05,29.75-.05,44.62h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.27,758.81c-3.75-2.22-7.45-4.5-10.82-7.29.7-7.34.2-14.7.31-22.04.24-1.04,1.02-1.14,1.71-.7,3.87,2.48,7.66,5.1,11.28,7.92.54.42.74,1.11-.07,1.62-1.53.61-1.57,1.93-1.58,3.27-.02,4.5.02,8.99-.02,13.49-.01,1.28.23,2.65-.82,3.72h0Z",
    style: {
      fill: "#94929b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.75,717.03c-3.29-2.34-6.29-5-9.08-7.91.79-1.64,1.07-3.37,1-5.19-.25-6.36.5-12.75-.5-19.09.37-1.65,1.47-1,2.08-.42,2.97,2.82,6.25,5.36,8.57,8.83.18,7.31.12,14.61-.08,21.91-.03,1.03-.19,2.45-1.98,1.87h0Z",
    style: {
      fill: "#b9b7bb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.1,736.81c-3.4-2.18-6.55-4.69-9.54-7.4,1.24-.96,1.45-2.28,1.44-3.76-.03-4.98-.06-9.96.02-14.94.02-1.22.11-2.44.5-3.62.23-.5.79-.79,1.13-.54,3.12,2.24,6.8,3.89,8.39,7.79.33,6.46.16,12.93.1,19.39-.01,1.33.02,2.96-2.02,3.07h0Z",
    style: {
      fill: "#a8a6ac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,683.99c.86,1.39,1.1,2.88,1.09,4.52-.07,5.91-.04,11.82-.02,17.73,0,1.39,0,2.71-1.85,2.88-3.77-2.97-7.35-6.14-10.61-9.67,1.59-.89,2.26.81,3.73,1.34.04-4.73.08-9.33,0-13.93-.06-3.33.59-6.72-.63-9.98.12-.77.71-.98,1.2-.57,2.67,2.27,5.62,4.31,7.11,7.68h0Z",
    style: {
      fill: "#c0bec1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.75,717.03c.91-.12,1.23-.68,1.24-1.56.13-7.21-.29-14.43.25-21.64.03-.35-.18-.72-.28-1.09,3.46,1.23,5.86,3.69,7.78,6.72.68,1.06.98,2.25,1,3.49.08,6.02.11,12.05-.03,18.07-.03,1.17.4,3.1-1.99,2.77-2.83-2.05-5.62-4.15-7.97-6.76h0Z",
    style: {
      fill: "#b4b1b6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.72,723.78c1.36-.19,1.18-1.23,1.18-2.15,0-6.37-.07-12.75.06-19.12.03-1.46-1.12-2.35-1.17-3.66,3.9,1.64,7.09,4.09,9.04,7.95.67,2.12-.12,4.22-.05,6.34.16,4.87-.05,9.77.1,14.64.06,2.06-.77,2.16-2.3,1.63-2.5-1.61-4.74-3.54-6.84-5.63h0Z",
    style: {
      fill: "#aeacb2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.12,728.77c.81,1.59.51,3.3.53,4.97.03,4.97,0,9.93.01,14.9,0,1.14.1,2.3-1.2,2.88-3.28-1.69-6.17-3.94-9-6.27.75-.71,1.48-1.39,1.48-2.57,0-5.8.03-11.6-.01-17.4,0-.75-.41-1.44-.49-2.18.03-.61.54-.93.92-.71,2.94,1.69,6.1,3.13,7.76,6.38h0Z",
    style: {
      fill: "#9b99a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.27,737.21c1.86-1.95,3.94-3.63,6.2-5.08,1.62.77,1.44,2.31,1.45,3.68.08,4.9.05,9.79.02,14.69-.01,1.49.27,2.79,1.43,3.81-2.4,2.37-5.12,4.34-7.91,6.23-1.5-.1-1.82-1.31-1.87-2.39-.32-6.37-.24-12.75-.06-19.11.02-.68.38-1.24.74-1.8h0Z",
    style: {
      fill: "#adabb1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.1,736.81c1.44-.65,1.19-1.95,1.19-3.14.01-6.71.01-13.41.02-20.13,3.42.57,5.38,3,7.2,5.63.88,6.79.44,13.6.27,20.39-.03,1.06-.36,2.28-1.88,2.33-2.47-1.43-4.8-3.03-6.79-5.09h0Z",
    style: {
      fill: "#a3a1a8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.71,727.04c1.87-1.96,3.93-3.69,6.2-5.17,1.13,1.01.91,2.39.92,3.66.05,5.03.02,10.07.02,15.1,0,1.53.08,2.99,1.39,4.05-1.9,1.9-3.94,3.64-6.2,5.1-1.67,1.17-2.61.49-2.97-1.28-.34-1.66-.18-3.36-.19-5.04-.01-4.12,0-8.23-.01-12.35,0-1.43.16-2.8.85-4.07h0Z",
    style: {
      fill: "#b8b6bb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.24,744.68c-2.19.74-2.27-.58-2.27-2.2.01-6.87-.03-13.74-.06-20.61,1.89-2.06,4-3.86,6.3-5.45,1.16,1.24.83,2.79.88,4.25.21,6.51-.41,13.04.41,19.54-1.49,1.8-3.38,3.12-5.26,4.46h0Z",
    style: {
      fill: "#bebcc0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.46,676.25c1.68,1.94,1.18,4.24,1.15,6.5-.07,6.52-.03,13.05-.03,19.72-2.05-.6-2.55-2.91-4.54-3.03-1.16-.73-2.09-1.7-2.91-2.79,1.71-.36,1.78-1.71,1.78-3.04.02-6.45-.06-12.91.06-19.36.03-1.46-1.09-2.35-1.18-3.65,2.84.92,4.73,2.81,5.66,5.66h0Z",
    style: {
      fill: "#c4c1c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.49,740.22c-1.71-.26-1.27-1.61-1.28-2.65-.02-7.05-.01-14.1-.01-21.14,1.97-1.87,3.86-3.85,6.17-5.32.59,6.32.24,12.66.32,18.98.02,1.69,0,3.36.46,5,.19,1.41-.58,2.07-1.84,2.35-1.28.93-2.55,1.85-3.83,2.78h0Z",
    style: {
      fill: "#c3c1c4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.71,727.04c.02,6.85.06,13.7.03,20.56,0,1.65.16,2.87,2.28,2.18-1.69,1.75-3.61,3.21-5.66,4.52-1.95.82-2.33-.06-2.3-1.88.08-5.59.02-11.19.03-16.78,0-1.22.06-2.43-.63-3.52,1.87-1.96,3.99-3.6,6.24-5.09Z",
    style: {
      fill: "#b2b0b5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.97,765.13c-1.92-.55-3.56-1.59-5.07-2.87-1.23-.84-1.41-2.12-1.43-3.46-.05-5.21-.05-10.43.01-15.64.01-1.19-.03-2.47,1.15-3.27,3.18-.02,6.42,2.08,7.2,4.68-.87,5.3-.19,10.64-.42,15.96-.07,1.65.2,3.43-1.46,4.59h0Z",
    style: {
      fill: "#9d9ba2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.89,741.9c.88-.7,1.19-1.64,1.19-2.71,0-6.16.02-12.33-.02-18.49,0-.72-.32-1.44-.49-2.17,2.58.18,4.13,1.67,5.1,3.95.96,1.3,1.21,2.65,1.15,4.33-.19,5.51-.13,11.04-.04,16.56.03,1.84-.37,2.69-2.32,1.88-1.72-.84-3.21-2-4.56-3.35h0Z",
    style: {
      fill: "#9e9ca4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.97,765.13c1.3-6.08.27-12.24.62-18.36.06-1.01-.53-2.37,1.18-2.69.8-.9,1.5-1.94,2.84-2.11.34-.08.68-.16,1.02-.23,1.56,1.33,1.42,3.19,1.46,4.95.13,5.92-.17,11.84.21,17.75-3.25,3.46-3.94,3.52-7.32.68h0Z",
    style: {
      fill: "#a3a0a8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.29,764.44c-1.28-.64-1.06-1.84-1.06-2.94,0-4.29-.06-8.57.02-12.85.04-2.34-.12-4.63-.63-6.91,1.63-1.82,3.53-3.3,5.64-4.54.02,6.57.04,13.14.05,19.71,0,1.33-.02,2.65,1.15,3.6-1.44,1.69-3.37,2.71-5.17,3.92h0Z",
    style: {
      fill: "#a7a5ab",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.51,740.15c-.77.1-1.15.54-1.15,1.33.02,6.49.02,12.98.07,19.47,0,.44.31.88.48,1.32-2.09-.82-3.82-2.2-5.64-3.46,0-6.2.07-12.39-.04-18.59-.04-2.28.64-3.18,2.92-2.35,1.69-.09,2.95.46,3.35,2.27h0Z",
    style: {
      fill: "#97959d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.32,737.44l1.7-1.8c1.85-2.23,3.57-4.63,6.68-5.27.21.25.43.5.65.75-2.45,2.6-5.34,4.65-8.31,6.59-.12.08-.48-.17-.72-.27h0Z",
    style: {
      fill: "#4c5a8b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.13,476.64c-1.22,1.98-1.88,4.26-3.46,6.06-4.24,4.82-9.57,6.63-15.86,5.9-4.04-.75-7.33-2.86-10.21-5.71-3.57-3-4.37-7.14-4.7-11.47,0-10.34,0-20.68,0-31.01.06-8.47,0-16.94.04-25.41.01-1.58-.23-3-1.5-4.06-7.31-6.08-10.74-14.07-11.49-23.38.28-5.42,1.57-10.6,3.89-15.52,3.07-3.98,6.17-7.92,10.48-10.69,4.33-2.57,8.98-4.14,13.98-4.73.3-.03.6-.03.9-.03,5.88-.21,11.37,1.15,16.49,4.04,3.53,1.58,5.88,4.58,8.54,7.19,1.69,2.06,3.06,4.31,4.22,6.71,1.74,3.62,2.28,7.56,2.9,11.46-.08,9.41-3.34,17.5-10.29,23.89-1.84,1.69-2.69,3.45-2.61,5.89.08,2.25-.05,4.51-.03,6.77.11,14.29-.89,28.56-.51,42.85-.03,3.76.28,7.54-.77,11.24h0Z",
    style: {
      fill: "#fefefe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,391.36c-1.13-4.48-1.14-9.09-1.46-13.65-.53-7.3-1.07-14.61-.81-21.95-.51-5.53-.2-11.08-.18-16.61.01-2.22,1.75-1.54,2.87-1,3.12,1.54,6.08,3.4,9.1,5.12,23.2,13.26,46.53,26.3,69.76,39.5,17.34,9.85,34.69,19.69,52.08,29.44,15.92,8.92,31.78,17.96,47.73,26.83,2.71,1.5,5.26,3.31,8.11,4.58,1.78.8,2.45,2.13,2.44,4.04-.04,4.89-.03,9.79,0,14.69-.75,3.12-2.2,3.94-5.28,2.97.79-1.14.1-1.59-.84-2.12-12.38-6.91-24.77-13.82-37.1-20.81-15.91-9.02-31.77-18.16-47.68-27.18-11.19-6.35-22.46-12.57-33.68-18.86-5.81-3.26-11.59-6.58-17.4-9.86-10.21-5.76-20.44-11.5-30.65-17.27-5.15-2.91-10.28-5.86-15.41-8.79-.9-.51-1.94-1.29-2.86-.84-.91.45-.39,1.71-.37,2.58.16,7.78.69,15.52,1.59,23.25.23,1.95.04,3.95.04,5.93h0Z",
    style: {
      fill: "#23467c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.86,465.32c1.62-.89,5,.79,4.58-3.11.29-6.07.53-12.14-.16-18.22-.29-2.61-.34-5.28,0-7.87.33-2.54-.71-3.89-2.64-5.32-7.1-5.24-13.08-11.52-17-19.56-3.49-6.79-5.59-14-6.46-21.59-.14-6.82-.33-13.64.64-20.42.98-5.73,2.24-11.39,4.52-16.77,2.14-4.97,4.74-9.66,8.02-13.97,2.13-2.48,3.95-5.23,6.48-7.37,1.1-.64,2.02-1.49,2.78-2.51.27-.29.59-.53.93-.74,5-3.59,10.3-6.66,15.98-9.07,3.57-1.05,7.08-2.34,10.74-3.04,1.6-.31,2.36-1.19,2.56-2.82.23-1.82.27-3.76,1.7-5.21,2.72-3.46,6.12-5.82,10.55-6.53,2.78-.21,5.49.03,8.06,1.2,4.07,2.18,6.8,5.45,8.05,9.93,1.19,10.21-4.2,16.98-14.33,17.99-.29,0-.59-.03-.88-.08-5.76-.94-10.16-3.73-12.5-9.29-.56-1.33-1.44-1.8-2.9-1.46-8.14,1.87-15.79,4.82-22.55,9.83-4.65,3.37-9,7.06-12.16,11.96-4.49,5.93-7.76,12.45-9.4,19.74-.74,3.41-1.77,6.77-1.87,10.29-.76,5.3-.48,10.63-.58,15.94.45,10.81,3.89,20.57,10.38,29.25,3.56,5.07,8.1,9.1,13.23,12.49,2.23,1.47,2.93,3.21,2.61,5.93-.65,5.59-.2,11.25-.24,16.88.19,2.84-.33,5.63-.58,8.43-.19,2.18.5,3.52,2.8,4.12,3.62.96,6.23,3.32,8.19,6.5,1.91,3.09,1.92,6.33,1.16,9.71-2.48,7.35-6.71,11.03-13.05,11.35-5.71.29-10.82-2.75-13.23-7.88-2.39-5.08-1.48-11.07,2.36-15.22,1.24-1.35,2.56-2.65,4.2-3.53h0Z",
    style: {
      fill: "#fdfdfe",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.59,480.6c.05-9.28-2.82-13.35-11.36-15.93-1.05-.32-1.53-.74-1.46-1.94.22-3.64.31-7.3.45-10.95.77-4.68.73-4.59,5.22-2.24,4.81,2.52,9.4,5.43,14.21,7.95.72.38,1.63.58,1.76,1.62.15,4.34-.31,8.69.24,13.01.32,3.96,1.69,7.53,3.96,10.77-3.17-1.7-6.38-3.32-9.5-5.11-2.09-1.2-3.23-1.21-2.91,1.65.06.49-.18.89-.62,1.16h0Z",
    style: {
      fill: "#23457b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.51,740.15c-.97-.98-2.12-1.69-3.36-2.27-4.21-3.23-8.54-6.28-13.04-9.1-2.67-2.3-5.45-4.46-8.45-6.29-1.54-1.52-3.18-2.91-5.1-3.95-1.98-1.8-3.94-3.62-6.26-4.99-2.7-2.41-5.29-4.97-8.49-6.75-2.68-3.03-5.85-5.49-9.04-7.95-2.08-2.25-4.41-4.22-6.81-6.11-3.14-2.96-6.07-6.14-9.52-8.75-2.53-2.71-5.1-5.39-7.99-7.74-1.69-2.09-3.56-3.98-5.66-5.66-.21-.35-.42-.7-.63-1.05.7-.92,1.71-.62,2.61-.62,29.28-.01,58.57.02,87.84-.06,2.43,0,2.95.79,2.95,3.06-.05,23.35,0,46.69.03,70.05-.79.92-1.56,1.87-2.84,2.11-1.96-1.51-4.01-2.88-6.25-3.94h.01Z",
    style: {
      fill: "#224176",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560,673.98c-.02.19.02.46-.08.54-3.54,2.75-2.71,6.66-2.73,10.33-.02,4.8-.01,9.6,0,14.4,0,1.11-.24,2.32,1.04,2.98-1.84,2.48-4.21,4.39-6.6,6.29-2.54.46-2.46-1.58-2.59-3.01-.32-3.45-.1-6.92-.12-10.38-.02-2.53,0-5.06,0-7.58,0-1.26.34-2.4.86-3.51,3.41-3.35,6.81-6.71,10.22-10.06h0Z",
    style: {
      fill: "#e5e2e1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.55,723.77c-.39.37-.79.74-1.18,1.11-2.14.29-1.85-1.45-1.91-2.56-.2-4.13-.16-8.27-.05-12.41.08-2.99-.55-6.01.23-8.97,2.18-2.16,4.28-4.42,6.8-6.2,1.2.74,1.44,1.97,1.45,3.2.04,7.14.35,14.29-.18,21.43-.78,1.1-1.79,1.96-2.92,2.68-.78.53-1.48,1.17-2.25,1.71h0Z",
    style: {
      fill: "#d5d2d3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.65,700.95c1.15,3.27.54,6.65.62,9.98.09,3.82,0,7.65.04,11.47.01.93-.48,2.17,1.06,2.48-1.19,2.07-3.35,3.05-5.08,4.52-2.24,1.5-3.27,1.33-3.42-.96-.47-6.84-.42-13.71-.02-20.56.03-.46.36-.87.58-1.28,1.89-2.08,4.01-3.92,6.22-5.65h0Z",
    style: {
      fill: "#ceccce",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.77,684.05c.02,6.96.02,13.91.06,20.87,0,1.47-.25,3.13,1.79,3.62-1.88,2.12-3.84,4.15-6.3,5.62-1.76,0-1.88-1.37-1.92-2.54-.2-6.67-.07-13.35-.08-20.02,0-2.37,2.46-3.14,3.62-4.78.8-1.06,1.66-2.07,2.83-2.76h0Z",
    style: {
      fill: "#dfdcdc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.43,706.6c.02,6.94.09,13.89.05,20.84-.01,2.22.59,3.15,2.82,1.96-.2.33-.4.65-.61.98-2.23,1.75-4.46,3.51-6.68,5.27-1.18-.52-1.15-1.55-1.16-2.61-.06-6.63-.1-13.26-.23-19.88-.02-.85.74-1.28.75-2.05,1.56-1.65,3.1-3.31,5.06-4.51Z",
    style: {
      fill: "#c9c6c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.94,686.8c-3.5,2.78-2.75,6.68-2.77,10.38-.02,4.69,0,9.38,0,14.06,0,1.12-.18,2.31,1.15,2.9-.79,1.5-2.15,2.41-3.47,3.36-.71.62-1.53,1.11-2.15,1.82l.03.03c-.92-.8-.63-1.89-.63-2.88-.02-5.6-.04-11.19,0-16.79.02-1.7-.12-3.34-.65-4.95,2.71-2.77,5.37-5.6,8.49-7.95h0Z",
    style: {
      fill: "#dad8d8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.56,310.96c.84.82.47,1.88.55,2.84-.94-.8-.44-1.88-.55-2.84Z",
    style: {
      fill: "#4f6b9b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.36,301.95c1.4.9,2.98.46,4.48.58,1.27.68,2.74-.16,4.02.52.38.02.76.04,1.14.06,2.18.88,4.47.45,6.72.56,3.35,1.04,6.79.35,10.18.56.05.17.08.33.14.5-6.01.24-11.99-.15-17.94-.95-.74-.1-1.22.11-1.73.63-8.86,9.17-18.72,17.26-28.16,25.81-7.16,6.49-14.26,13.04-21.34,19.62-8.93,8.3-18.01,16.42-27.2,24.42-4.46,3.88-8.8,7.89-13.1,11.94-4.24,3.98-8.51,7.91-13.1,11.49-.79.61-1.13,1.36-1.41,2.32-.61,2.02-.54,4.33-2.21,5.96,2.05-7.32,3.79-14.69,3.48-22.37-.05-1.09.55-1.41,1.43-1.71,9.63-3.36,12.58-8.81,10.3-18.85,3.08-3.69,6.96-6.54,10.48-9.75,4.73-4.29,9.56-8.47,14.23-12.83,8.44-7.87,16.86-15.77,25.56-23.38,5.94-5.19,11.66-10.64,17.6-15.82.99-.87,2.02-1.75,3.5-1.03,3.03.07,5.9,1.31,8.96,1.16,1.26.74,2.75-.21,4,.58h-.02v-.02Z",
    style: {
      fill: "#597cac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.1,304.75c3.21,0,6.41,0,9.62-.01-4.33,2.66-7.8,6.38-11.58,9.7-11.27,9.91-22.38,20-33.52,30.06-4.95,4.47-9.86,8.97-14.7,13.56-9.53,9.05-19.4,17.71-29.23,26.43-6.39,5.67-12.57,11.56-18.98,17.2-10.48,9.22-20.25,19.22-30.93,28.22-5.88,4.95-11.47,10.25-17.16,15.42-.85.77-1.72,1.45-2.77,1.91-1.7-6.45,2.26-10.07,6.58-13.74,9.74-8.25,19.06-16.98,28.52-25.54,8.77-7.93,17.51-15.9,26.19-23.94,10.05-9.3,20.45-18.22,30.64-27.37,6.84-6.15,13.63-12.36,20.35-18.65,9.44-8.82,19.09-17.42,28.75-26,2.73-2.43,5.43-4.89,8.21-7.27h0Z",
    style: {
      fill: "#5373a3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.23,304.21c1.7-.02,3.39-.05,5.08-.06,2.49.35,4.89-.46,7.35-.55l3.39.02c-3.7,1.09-7.49,1.18-11.3,1.15-1.72-.01-3.45-.02-5.17-.03.21-.18.43-.35.65-.52h0Z",
    style: {
      fill: "#5271a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.48,382.16c.98-.1,1.62.12,1.62,1.32-.03,7.75-.84,15.36-4.05,22.54-.17-.68.37-1.65-.54-2-.73-.28-1.11.54-1.57.96-8.52,7.75-17.02,15.51-25.54,23.25-3.74,3.4-7.52,6.75-11.26,10.15-.85.77-1.76,1.39-2.94,1.53-.62-7.11-.14-14.23-.26-21.34-.02-.94.72-1.48,1.33-2.06,7.18-6.75,14.62-13.2,21.91-19.83,4.31-3.91,8.54-7.91,12.69-11.98,2.53-2.49,4.98-4.21,8.6-2.53h0Z",
    style: {
      fill: "#597cac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.48,382.16c-3.85-1.1-6.11,1.24-8.63,3.62-9.91,9.4-19.92,18.7-30.29,27.59-1.64,1.4-3.09,3.03-4.71,4.45-.88.77-.63,1.71-.64,2.61-.02,6.49-.01,12.98-.01,19.47,0,8.48,0,16.96-.01,25.44-.19.25-.38.27-.58,0-.03-15.72.02-31.44-.15-47.16-.05-4.01.58-6.99,3.99-9.95,6.66-5.8,9.03-13.87,9.13-22.6,2.56-3.14,5.92-5.42,8.84-8.16,2.86-2.67,5.69-5.42,8.79-7.83.83-.64,1.49-1.85,2.86-.98.09.14.08.27-.02.39.54.94-.19,2.11.54,3.01,1.87,5.27,5.58,8.55,10.89,10.1h0Z",
    style: {
      fill: "#5c82b2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.61,465.35h.58c0,.57,0,1.14.01,1.7-.18,3.22.57,6.54-1.07,9.6.16-3.77.32-7.53.48-11.3Z",
    style: {
      fill: "#597cac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,411.07c4.85,8.3,10.88,15.51,19.13,20.66.68.43,1.12.94,1.1,1.81-.28,9.47-.54,18.94-.82,28.41,0,.08-.07.17-.11.26-.02-4.9-.11-9.79-.02-14.69.03-1.65-.58-2.47-2-3.26-12.45-6.98-24.83-14.08-37.26-21.09-9.9-5.58-19.86-11.06-29.76-16.63-8.51-4.79-16.97-9.66-25.47-14.48-8.48-4.81-16.99-9.58-25.48-14.38-8.83-4.99-17.65-9.99-26.48-14.98-8.5-4.81-17.01-9.59-25.5-14.41-5.23-2.96-10.42-5.99-15.66-8.92-.93-.51-1.94-1.62-3.06-.93-.98.62-.45,1.92-.46,2.91-.06,4.8-.05,9.61-.07,14.42-.87-3.31-.4-6.69-.39-10.03.02-7.95.34-15.89.57-23.84.01-.44.24-.88.37-1.32.8-1.4.28-2.92.33-4.38.05-1.5.69-1.81,1.97-1.4.54.18,1.05.43,1.53.72,14.82,8.96,30.09,17.12,45.12,25.72,11.92,6.83,23.96,13.45,35.92,20.2,11.55,6.51,23.09,13.05,34.63,19.59,16.45,9.32,32.87,18.71,49.45,27.78,1.04.57,1.83,1.28,2.45,2.26h-.01Z",
    style: {
      fill: "#244b81",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,411.07c-7.35-4.15-14.69-8.3-22.03-12.44-10.22-5.76-20.44-11.53-30.66-17.27-9.49-5.34-19.01-10.63-28.48-15.99-11.84-6.71-23.62-13.52-35.46-20.21-9.88-5.59-19.83-11.04-29.71-16.61-6.94-3.92-13.83-7.94-20.75-11.92-1.03-.59-2.15-1.81-3.22-1.23-.99.53-.29,2.08-.42,3.17-.08.73.15,1.54-.64,2.03-.21-4.98.63-9.92.69-14.89.03-2.63,1.84-2.04,3.34-2.13,1.5.21,2.97.8,4.53.53,2.63.31,5.24.88,7.91.62,2.45.21,4.9.42,7.35.64,8.09,4.6,16.16,9.26,24.28,13.82,15.43,8.65,30.78,17.45,46.23,26.08,16.34,9.14,32.6,18.43,48.94,27.56,6.81,3.81,13.57,7.72,20.42,11.46,1,.54,1.22,1.24,1.24,2.27.03,1.19-.34,2.43.25,3.59,1.01,7.29,3.14,14.25,6.22,20.93h0Z",
    style: {
      fill: "#255188",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.45,200.67c1.72.28,1.23,1.64,1.23,2.66.03,6.19.01,12.38.02,18.57,0,1.2-.24,2.51,1.18,3.18-1.89,3.66-4.48,6.57-8.51,7.93-1.06-3.19-.49-6.48-.57-9.73-.08-3.55.1-7.1-.06-10.65-.11-2.51.2-4.8,1.74-6.84,1.66-1.71,3.31-3.43,4.97-5.14h0Z",
    style: {
      fill: "#93919a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.42,300.22c-2.3-.12-3.49,1.8-4.87,3-6.76,5.92-13.3,12.09-19.97,18.11-4.51,4.07-9.4,7.76-13.6,12.14-4.15,4.34-8.71,8.19-13.09,12.25-5.89,5.48-11.92,10.82-17.92,16.2-.54.49-1.3.74-1.95,1.11-1.59-3.01-3.91-5.36-6.73-7.23-1.23-1.17-2.93-1.17-4.41-1.48-1.83-.38-1.4-1.07-.72-2.04,2.23-3.2,5.36-5.53,8.21-8.08,6.71-6.02,13.37-12.09,20.12-18.07,7.31-6.48,14.57-13.01,21.73-19.65,3.37-3.13,6.94-6.05,10.13-9.38,1.06-1.11,2.18-2.15,3.92-1.46.69.03,1.37.06,2.06.08,2.91,1.16,5.94,1.85,9.04,2.27,2.51,1.07,5.17,1.48,7.87,1.72.05.16.1.33.15.49h0Z",
    style: {
      fill: "#5d82b2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.3,295.66c-.98,0-1.78.3-2.53,1.01-5.6,5.27-11.16,10.58-16.87,15.73-8.27,7.47-16.66,14.79-24.96,22.22-4.68,4.19-9.29,8.45-13.89,12.72-2.1,1.95-4.52,3.61-5.89,6.25,1.53,1.18,3.95.3,5.16,2.22-5.47-1.91-10.65-1.76-15.31,2.17-3.33,2.8-4.37,6.62-4.93,10.68-2.58.84-4.13,3.07-6.09,4.7-4.21,3.51-8.17,7.33-12.26,10.99-.61.54-1.43.87-2.14,1.29-.55-3.85-1.43-7.61-2.8-11.25-.38-.85.34-1.2.8-1.58,10.65-8.96,20.33-19,30.85-28.12,8.45-7.32,16.56-15.05,24.97-22.42,10.32-9.05,20.01-18.79,30.42-27.74,1.31-1.12,2.13-3.4,4.58-2.19.83.87,1.9.46,2.87.56,2.41,1.69,5.42,1.69,8.04,2.78h0Z",
    style: {
      fill: "#5f86b6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.87,377.89c-4.25-2.58-6.17-7.34-4.99-12.33,1.1-4.63,5.43-8.31,10.26-8.73,4.86-.42,9.26,2.22,11.23,6.73-1.03.32-2.19.11-3.1.99-4.03,3.87-8.31,7.47-12.27,11.43-.55.55-.67,1.32-1.14,1.91h0Z",
    style: {
      fill: "#5d82b2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.87,377.89c-.59-1.18.17-2.02.87-2.69,3.98-3.77,8-7.49,12.06-11.16,1.01-.91,2.19-1.78,3.57-.48,2.35,4.72,1.22,10.24-2.81,13.66-3.99,3.39-9.51,3.66-13.69.67h0Z",
    style: {
      fill: "#5a7eae",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.59,372.06c-1.01-.85-.49-1.98-.54-3.01.59.93.5,1.98.54,3.01Z",
    style: {
      fill: "#5f86b6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,352.31c-1.85,5.4-3.39,10.89-4.47,16.5-4.94-3.45-10.28-6.23-15.5-9.21-12.49-7.13-25-14.26-37.55-21.27-16-8.94-31.88-18.11-47.94-26.96-1.98-1.09-3.82-2.4-5.79-3.51-2.48-1.4-4.87-2.82-7.89-2.47-.54.06-1.12-.16-1.46-.7.07-.16.15-.31.24-.45,1.91-.03,3.83.19,5.67-.55,1.54.01,3.1.12,4.56-.54,2.69-.05,5.34-.38,7.92-1.13,4.1-.08,7.99-1.57,12.06-1.85,1.16-.42,2.23-.13,3.22.48,9.92,6.1,20.3,11.42,30.37,17.26,7.23,4.19,14.59,8.17,21.86,12.31,11.1,6.32,22.27,12.51,33.33,18.91,1.25.72,2.12,1.6,1.37,3.18h0Z",
    style: {
      fill: "#275a93",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,352.31c.02-.99-.2-1.78-1.19-2.34-6.94-3.91-13.85-7.87-20.78-11.8-9.3-5.26-18.62-10.49-27.92-15.75-8.08-4.56-16.15-9.14-24.22-13.71-4.48-2.54-8.99-5.04-13.44-7.65-.84-.49-1.63-.89-2.6-.89,1.02-.36,2.03-.72,3.05-1.08,3.68-.54,7.27-1.48,10.77-2.73,2.01-.42,4.01-.85,6.02-1.27,1.58-.58,2.94.05,4.29.76,6.41,3.38,12.61,7.12,18.93,10.64,17.41,9.7,34.72,19.6,52.07,29.42,1.14.65,2.77.92,2.88,2.71-3,4.35-5.55,8.95-7.87,13.69h.01Z",
    style: {
      fill: "#285e98",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,679.09c1.26-3.33.24-6.79.57-10.17,2.25,0,4.5.06,6.74-.03,1.63-.07,2.37.41,2.34,2.2-.09,4.87-.03,9.74-.03,14.61,0,.74.17,1.66-.64,2-.72.3-1.13-.5-1.56-.94-2.48-2.54-4.94-5.11-7.4-7.66h0Z",
    style: {
      fill: "#d0cdcf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.96,259.51c1.15-.92,2.29-1.84,3.44-2.76,2.41-1.07,4.21-2.96,6.2-4.59,3.19-1.32,5.39-4.09,8.38-5.7,2.3-.01,3.99,1.48,5.8,2.52,9.33,5.38,18.89,10.34,28.03,16.06,1.39.87,3.41.68,4.18,2.56.61,4.02.16,8.06.29,12.08.08,2.53-.16,5.07.34,7.58.21,3.64.18,7.29.2,10.94.01,1.03-.02,2.06-.61,2.97-1.58.62-1.39-.71-1.47-1.47-.2-1.97-.11-3.95-.07-5.93.03-1.6-.63-2.52-2.05-3.33-14.14-8.08-28.31-16.12-42.57-24-2.71-1.5-5.34-3.17-8.01-4.77-.88-.53-1.86-.98-2.09-2.15h0Z",
    style: {
      fill: "#2d75b3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.42,266.87c-2.74.02-4.61-1.84-6.79-3.08-9.48-5.37-19-10.66-28.5-15.99-.74-.41-1.43-.9-2.14-1.35.42-.51.85-1.02,1.27-1.53,2.33-1.38,4.38-3.1,6.22-5.08,2.57-1.3,4.25-3.77,6.71-5.21.8-.58,1.57-.38,2.39,0,6.96,3.33,13.41,7.59,20.26,11.15.61.32,1,.84,1.2,1.51.55,5.85.23,11.71.19,17.55,0,.75-.2,1.48-.8,2.02h0Z",
    style: {
      fill: "#2e79b9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.38,292.32c-3.15.05-4.43,2.91-6.33,4.58-6.64,5.79-12.83,12.09-19.37,18.01-10.13,9.17-20.42,18.18-30.61,27.29-6.14,5.5-12.36,10.92-18.29,16.65-5.53,5.34-11.15,10.57-17.01,15.54-1.31-2.08-2.63-4.15-3.94-6.23-1.86-2.71-1.95-2.97.46-5.1,8.9-7.83,17.51-15.96,26.4-23.8,6.76-5.97,13.43-12.07,20.08-18.18,7.61-7,15.19-14.04,22.95-20.89,3.24-2.86,6.43-5.79,9.56-8.78,1.48-1.41,2.9-2.97,5.04-3.46,1.12.16,2.18.48,3.16,1.05h-.03c2.64,1.11,5.29,2.22,7.93,3.33h0Z",
    style: {
      fill: "#618ab9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.42,266.87v-20.35c-.82-.9-.9-2.02-.91-3.16-.04-9.44-.01-18.89-.02-28.33,0-.85.25-1.66.37-2.49.37-.19.75-.37,1.13-.56,2.04,2.14,3.78,4.55,6.2,6.31,1.85,2.3,3.94,4.35,6.22,6.24,2.08,2.43,4.29,4.73,6.81,6.71,2.41,1.74,3.94,4.5,6.75,5.76,1.15,1.33,2.15,2.83,3.96,3.39,1.16,1.71,2.84,2.81,4.55,3.89,2.1,1.92,4.13,3.92,6.76,5.16,1.29,1.95,3.79,2.52,5.08,4.47-.69,1.79-2.42,2.58-3.72,3.76-8.52,7.68-17.29,15.07-25.39,23.21-4.18,4.2-8.91,7.8-13.15,11.94-.4.4-.88.71-1.38.98-1.82,1-2.26.73-2.41-1.28-.14-1.75.41-3.54-.33-5.25-.97-1.56-.42-3.29-.45-4.93-.09-5.15-.05-10.29-.06-15.44v-.02Z",
    style: {
      fill: "#72a5d5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.92,668.93h10.16c.76.8.92,1.82.86,2.84-.2,3.39.58,6.81-.28,10.18-2.88,3.47-5.8,6.92-9.42,9.67-1.56.15-2.01-.99-2.07-2.12-.29-6.36-.31-12.73,0-19.1.03-.57.35-1.06.75-1.48h0Z",
    style: {
      fill: "#f5f2ef",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.92,668.93c0,6.54,0,13.09-.01,19.62,0,1.23-.14,2.49,1.33,3.07-1.54,1.85-3.2,3.61-5.13,5.07-1.06-.74-.68-1.85-.72-2.84-.29-7,.53-14.01-.45-21.01-.24-1.7,2.52-3.77,4.97-3.92h0Z",
    style: {
      fill: "#f0edeb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.66,681.96c-1.13-4.3-.32-8.69-.58-13.02.65,0,1.3-.02,1.95-.02,5.97-.01,6.73,1.06,4.89,6.9-1.96,2.18-3.7,4.57-6.25,6.15h0Z",
    style: {
      fill: "#eeecea",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.69,719.34c.36-1.03,1.03-1.69,2.15-1.82-.5.86-1.16,1.53-2.15,1.82Z",
    style: {
      fill: "#d5d2d3",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.55,723.77c.49-.92,1.11-1.66,2.25-1.71-.56.82-1.14,1.61-2.25,1.71Z",
    style: {
      fill: "#ceccce",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.9,361.47c-5.28-2.94-10.95-4.23-16.96-4.19-.63-.65-.76-1.48-.74-2.32.11-4.17-.44-8.34.12-12.49.16-.42.32-1.02.83-.98.83.07.94.87.98,1.5.21,2.91.03,5.83.12,8.74.03.98-.36,2.06.58,3.05,2.49-1.39,4.31-3.6,6.36-5.45,8.21-7.46,16.51-14.8,24.75-22.22,10.12-9.12,20.19-18.31,30.2-27.54,6.22-5.73,12.59-11.29,18.75-17.08,2.85-2.68,5.4-4.59,9.21-2.09.71.21,1.42.41,2.13.62,2.14,1.1,4.28,2.2,6.42,3.3-5.42,5.77-11.6,10.71-17.4,16.07-3.87,3.57-7.8,7.08-11.62,10.72-7.22,6.88-14.79,13.39-22.17,20.09-6.06,5.5-12.23,10.89-18.27,16.42-3.95,3.62-7.99,7.15-11.97,10.76-1,.9-1.37,1.86-1.33,3.1v-.02Z",
    style: {
      fill: "#6590c0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.9,361.47c-.7-1.1-.91-1.97.32-3.05,7.1-6.25,14.12-12.59,21.15-18.91,4.04-3.63,8.09-7.26,12.11-10.91,7.97-7.25,15.94-14.5,23.88-21.78,5.51-5.05,10.84-10.33,16.56-15.12,2.91-2.44,5.09-5.79,8.71-7.37,1.41.42,2.82.85,4.22,1.28,1.21.86,2.51,1.49,4,1.67.42.38,1.39.04,1.39,1.01-3.78,2.34-6.72,5.68-10,8.59-10.5,9.33-20.83,18.85-31.22,28.32-4.78,4.35-9.48,8.79-14.28,13.12-8.9,8.02-17.85,15.99-26.76,24.01-1.71,1.54-4.11,2.9-2.17,5.82-2.61-2.27-4.79-5.03-7.92-6.68h0Z",
    style: {
      fill: "#638dbd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.91,338.61c-5.16-3.62-10.85-6.35-16.29-9.49-10.74-6.18-21.53-12.3-32.33-18.38-8.76-4.93-17.57-9.77-26.36-14.65-1-.55-2.01-1.04-3.19-1.01,1.95-.75,3.89-1.5,5.83-2.25,2.16-.48,4.27-1.12,6.24-2.16,1.65-.17,3.1-.89,4.55-1.62,1.09-.29,2.18-.59,3.27-.88,8.46,4.3,16.57,9.23,24.82,13.9,8.26,4.67,16.6,9.18,24.77,13.98,5.42,3.19,11.05,6.02,16.41,9.31,1.12.68,2.67,1.26,1.92,3.15l-.63.55c-.97.76-1.95,1.52-2.7,2.52l-6.33,7.02h.01Z",
    style: {
      fill: "#29619c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.56,328.52c-.46-2.64-3-3-4.74-3.98-18.61-10.5-37.3-20.84-55.74-31.64-2.54-1.49-5.55-2.22-7.45-4.72,3.05-1.4,6.11-2.8,9.17-4.2,2.44-.55,4.56-1.83,6.74-2.99.7-.2,1.4-.41,2.1-.61,1.04-.41,1.97-.25,2.95.31,11.02,6.35,22.08,12.6,33.16,18.83,9.35,5.26,18.67,10.59,28.06,15.79.66.37,1.35.68,1.93,1.17,1.4,1.19,1.56,2.25-.36,3.05-5.49,2.62-10.72,5.67-15.82,8.97h0Z",
    style: {
      fill: "#2a65a1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.26,288.29c-.46-.34-.92-.67-1.39-1.01,1.72.08,3.35.38,4.6,1.71-1.07-.23-2.15-.47-3.22-.7h0Z",
    style: {
      fill: "#e4e1e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.1,280.41c-4.16-2-6.49.67-9.29,3.18-11.43,10.28-22.69,20.73-33.99,31.14-7.3,6.72-14.77,13.28-22.11,19.96-7.41,6.75-14.9,13.41-22.36,20.11-.69.62-1.48,1.49-2.4,1.01-.83-.42-.38-1.54-.4-2.35-.05-3.1,0-6.21-.03-9.31-.01-.9.32-1.91-.57-2.64-1.4-3.95-1.42-7.9,0-11.85.19-.01.39-.02.58-.03,1.34,3.52.61,7.06.46,10.39,6.58-5.95,13.5-12.14,20.39-18.37,9.98-9.01,19.8-18.18,29.8-27.17,6.71-6.03,13.49-11.99,20.06-18.19.48-.45,1.01-.87,1.43-1.36,1.79-2.1,3.76-2.58,6.03-.78,1.07.41,2.15.83,3.23,1.24,1.35,1.07,2.87,1.81,4.51,2.3,1.55.9,3.1,1.8,4.64,2.7h0Z",
    style: {
      fill: "#6896c5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.85,212.54c.77.65.56,1.55.56,2.37.01,10.54,0,21.08,0,31.61-4.07-1.43-7.65-3.81-11.35-5.94-3.85-2.22-7.64-4.52-11.88-5.95.4-.54.79-1.07,1.19-1.61,3.23-2.22,5.94-5,8.51-7.93h-.03c.96-.71,1.78-1.59,2.72-2.32.5-.63,1.48-.77,1.67-1.7,1.76-1.51,3.75-2.82,4.78-5.03,1.27-1.17,2.55-2.34,3.82-3.51h0Z",
    style: {
      fill: "#2f7ebf",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.38,301.96c-1.35-.1-2.76.28-4-.58,1.33.19,2.8-.57,4,.58Z",
    style: {
      fill: "#c6c4c7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.86,303.05c-1.35-.06-2.77.34-4.02-.52,1.34.15,2.79-.53,4.02.52Z",
    style: {
      fill: "#c0bdc1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.92,287.24c1.18,1.19.38,2.68.61,4.02.14.8-.41,1.92.4,2.35.96.5,1.72-.57,2.38-1.1,2.18-1.76,4.11-3.81,6.24-5.65,3.98-3.42,7.59-7.25,11.47-10.77,8.32-7.53,16.34-15.38,25.27-22.21.4.65.91,1.12,1.74,1.07,1.41,1.91,3.65,2.48,5.62,3.49.02.17.03.33.05.5-.7,1.96-2.36,3.16-3.82,4.41-12.01,10.35-23.37,21.42-35.15,32.01-2.66,2.4-5.92,4.37-7.46,7.87-2.7-1.2-5.53-1.52-8.44-1.3-.18-.53.06-.69.55-.64,1.15-2.28.36-4.72.5-7.08.14-2.32.02-4.65.02-6.98h.01Z",
    style: {
      fill: "#6fa1d1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.4,301.3c-.18.21-.37.43-.55.64-4.07.66-7.06,3.03-9.63,6.07-20.52-11.51-40.89-23.26-61.47-34.65-.97-.54-2.06-.96-2.61-2.06,1.21-.87,2.41-1.74,3.62-2.61,2.07-.83,3.95-1.97,5.64-3.42,2.25-1.05,4.37-2.3,6.22-3.96,1.11-.6,2.22-1.2,3.33-1.8,6.96,4.04,13.89,8.14,20.89,12.12,10.25,5.85,20.47,11.77,30.88,17.32,3.04,1.62,4.13,3.47,3.72,6.71-.24,1.85-.05,3.76-.05,5.63h0Z",
    style: {
      fill: "#2c6fac",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.29,303.24c-.57-1.39.14-2.32,1.11-3.18,6.75-5.93,13.4-11.97,19.91-18.16,8.27-7.86,16.91-15.32,25.4-22.95,1.69.96,3.36,1.92,5.05,2.89,2.09,1.49,4.18,2.97,6.27,4.46-4.37,4.13-8.94,8.05-13.36,12.11-3.18,2.93-6.54,5.67-9.62,8.71-7.76,7.69-16.07,14.78-24.22,22.03-1.13,1-1.94,2.31-3.24,3.12-1.43-3.83-3.69-6.97-7.31-9.03h0Z",
    style: {
      fill: "#6d9ece",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.6,312.27c.18-1.7,1.56-2.54,2.64-3.51,8.48-7.52,16.97-15.03,25.17-22.86,6.76-6.46,13.93-12.51,20.91-18.75.51-.45,1.02-.83,1.72-.84.35.04.71.08,1.06.12,1.31,1.26,2.88,2.09,4.55,2.77,1.87,1.49,3.94,2.65,6.2,3.46.63.51,1.26,1.02,1.88,1.53-2.18-1.14-3.87-.34-5.54,1.2-6.75,6.24-13.53,12.45-20.34,18.64-9.79,8.89-19.62,17.74-29.41,26.62-6.4,5.8-12.78,11.6-19.14,17.44-1.03.95-2.01,1.95-3.76,2.56v-10.99c7.84-.33,15.46-5.76,14.06-17.37h0Z",
    style: {
      fill: "#6a99c9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.14,271.31c6.74,3.08,12.96,7.11,19.44,10.67,7.79,4.28,15.44,8.81,23.19,13.17,6.69,3.78,13.42,7.49,20.14,11.21.7.38,1.27.79,1.32,1.66-1.44,1.85-1.57,4.11-1.89,6.28-.13.87-.17,1.55-1.28,1.83-4.24,1.07-8.45,2.26-12.67,3.41,1.72-1.54.55-2.28-.8-3.03-6.55-3.64-13.11-7.27-19.63-10.96-14.41-8.17-28.8-16.36-43.18-24.58-.7-.4-1.39-.52-2.13-.59.81-.54,1.62-1.07,2.43-1.61,2.43-.81,4.68-1.95,6.78-3.42,1.87-.62,3.51-1.65,5.11-2.77,1.31.19,1.99-1.19,3.18-1.28h0Z",
    style: {
      fill: "#2b6ba7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.44,304.7c6.78-1.01,11.26,3.78,16.47,6.63,8.15,4.44,16.15,9.15,24.23,13.72,6.7,3.78,13.41,7.53,20.12,11.29,12.98,7.3,25.97,14.61,38.95,21.92,5.14,2.9,10.26,5.84,15.43,8.69.87.48.8,1.15.93,1.87-.48,7.1-1.13,14.2-.64,21.34.25-6.27-5.39-7.11-9.1-9.22-14.43-8.22-28.91-16.37-43.35-24.59-14.68-8.37-29.54-16.43-44.25-24.74-12.58-7.11-25.06-14.39-37.61-21.57-1.63-.93-3.36-1.69-5.04-2.55-.9-.46-1.98-.78-2-2.1,1.32-.05,2.64-.08,3.96-.13,4.75.03,9.51.43,14.23-.41,2.56-.05,5.11-.08,7.67-.13h0Z",
    style: {
      fill: "#26558d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,304.76v-14.66c0-3.83.14-3.97,3.96-3.99h2.26c.01,6.19.02,12.37.03,18.55-2.08.03-4.16.07-6.24.1h0Z",
    style: {
      fill: "#d2cfd1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.58,222.77c-.67,1.05-1.39,2.04-2.72,2.31.62-1.1,1.33-2.1,2.72-2.31Z",
    style: {
      fill: "#93919a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.15,238.51c-.42-.63-1.14-.38-1.71-.55.59-.17,1.19-.38,1.79-.49.32-.06.84-.06.73.45-.05.24-.53.4-.81.59h0Z",
    style: {
      fill: "#a19ecb",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.31,324.49c.2,3.34-1.47,6.22-4.26,8.41-4.66,3.68-10.11,4.95-15.91,4.35-4.77-.5-7.74-3.43-9.43-7.85-3.34-8.75-3.38-8.75,5.46-10.87,6.58-1.58,13.17-3.1,19.73-4.74,1.7-.42,2.49-.22,2.85,1.75.51,2.86,1.44,5.64,1.56,8.96h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.67,291.88c-5.66-.16-9.65-1.96-11.74-6.81-1.98-4.61-1.03-9,3.05-12.8,4.98-4.63,10.93-6.98,17.78-6.53,4.63.3,7.99,2.66,9.7,7.05,1.69,4.3.67,8.19-2.34,11.52-4.56,5.04-10.52,7.04-16.46,7.57Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.44,316.81c-.02.25-.02.34-.03.44-.53,7.16-.95,7.45-7.82,5.53-.9-.25-1.8-.51-2.7-.76-3.99-1.11-4.12-1.44-2.13-5.25,2.13-4.12,5.86-5.97,9.34-4.73,2.38.84,3.34,2.54,3.33,4.78h0Z",
    style: {
      fill: "#5b57a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,314.6c-.02.19-.05.37-.06.56-.28,4.18-.63,4.44-4.57,3.37-1.98-.54-3.95-1.15-5.95-1.59-1.47-.33-1.84-1.01-1.22-2.36.31-.67.42-1.43.67-2.14,1.42-3.94,2.86-5.11,5.62-4.6,3.42.63,5.51,3.21,5.52,6.76h0Z",
    style: {
      fill: "#5c57a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,234.59c2.99-.08,6.5,3.81,6.06,7.52-.08.65-.24,1.3-.42,1.93-1.41,5.04-1.94,5.27-6.52,2.81-1.98-1.06-3.94-2.19-5.97-3.18-1.34-.66-1.5-1.39-.73-2.64.99-1.59,1.82-3.29,3.18-4.63,1.03-1.01,2.18-1.78,4.4-1.82h0Z",
    style: {
      fill: "#5b57a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.02,95.73c.02,2.95-4.17,7.78-6.97,8.1-.77.09-.98-.39-1.24-.87-1.7-3.14-3.37-6.3-5.09-9.43-.49-.9-.19-1.4.61-1.79,1.44-.69,2.84-1.5,4.34-2.01,4.71-1.62,8.31,1.01,8.35,6h0Z",
    style: {
      fill: "#5b56a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.91,107.96c-2.06-.14-4.22-1.2-6.33-2.46-.85-.51-.87-1.05-.4-1.83,1.84-3.04,3.71-6.07,5.46-9.17.67-1.19,1.35-1.03,2.24-.42,1.31.89,2.7,1.7,3.93,2.7,2.04,1.66,3.16,3.74,2.21,6.43-1,2.83-3.81,4.8-7.1,4.76h0Z",
    style: {
      fill: "#5b56a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.74,54.46c1.08,4.93,2.15,9.87,3.24,14.8.23,1.01.15,1.67-1.16,1.48-3.25-.49-6.5-.95-9.76-1.44-1.08-.16-1.45-.64-.81-1.71,2.62-4.43,5.21-8.87,7.81-13.31.23.06.45.12.68.19Z",
    style: {
      fill: "#5c57a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.83,566.09c0-4.15.06-8.3-.03-12.44-.03-1.71.53-2.38,2.27-2.29,2.82.15,5.64-.11,8.45.42,3.99.75,6.4,3.04,7.13,7.01.89,4.86.9,9.76,0,14.62-.86,4.61-3.66,7-8.42,7.26-2.44.13-4.9-.03-7.35.07-1.66.07-2.1-.7-2.08-2.21.06-4.15.02-8.29.02-12.44h0Z",
    style: {
      fill: "#5b56a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.69,585.81v-25.43c0-3.74,1.47-6.61,5.02-8.09,3.7-1.56,7.19-1.07,10.32,1.49,2.08,1.7,2.69,4.09,2.7,6.58.05,17.05.08,34.1-.01,51.15-.03,5.45-3.91,8.91-9.31,8.79-5.27-.11-8.67-3.59-8.7-9.06-.05-8.48-.01-16.95-.01-25.43h0Z",
    style: {
      fill: "#5b56a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.95,566.91c2.06,10.59,4.09,21.07,6.16,31.54.21,1.07.02,1.57-1.18,1.56-3.38-.03-6.77-.04-10.15,0-1.24.02-1.7-.42-1.45-1.67,2.04-10.32,4.06-20.63,6.1-30.94.03-.14.25-.25.53-.5h0Z",
    style: {
      fill: "#5b56a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,387.88c-.67-5.69-.06-11.34.6-16.98.18-2.24,1.23-2.28,2.94-1.31,8.45,4.82,16.91,9.64,25.4,14.4,1.86,1.04,4,1.66,5.49,3.33.69,9.57,4.26,17.67,12.07,23.6.77.59,1.01,1.24,1.01,2.15-.06,8.95-.08,17.89-.12,26.83-.34.16-.61.08-.82-.22-.77-1.66-.42-3.43-.48-5.15.06-5.74-.07-11.48.07-17.22.05-2.16-.68-3.52-2.56-4.54-9.08-4.95-18.07-10.08-27.04-15.22-5.54-3.17-11.38-5.86-16.55-9.67Z",
    style: {
      fill: "#26558d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,340.88c3.19-4.79,7.34-8.61,12.04-11.86,2.65.15,4.69,1.78,6.85,3.01,9.47,5.41,18.93,10.85,28.53,16.03,2.25,1.21,3.29,2.56,2.9,5.06-.21,1.37.29,2.8-.29,4.16-5.01.67-9.69,2.3-14.1,4.77-.1-1.66-1.05-2.63-2.47-3.39-9.52-5.1-18.8-10.64-28.24-15.88-1.66-.92-3.45-1.35-5.22-1.89h0Z",
    style: {
      fill: "#29629d",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.7,387.32c-6.02-2.2-11.33-5.81-16.88-8.9-4.98-2.77-10.1-5.36-14.85-8.53-1.72-1.15-1.49.52-2.11,1.01.26-3.48.81-6.9,2.07-10.18.92-2.12,1.56-4.35,2.3-6.53.7-2.05,1.71-1.9,3.14-1.16,3.76,1.95,7.33,4.21,11.09,6.15,5.76,2.97,11.15,6.6,16.93,9.56,1.24.64,2.93,1.19,2.26,3.25-2.15,4.89-3.67,9.95-3.95,15.32h0Z",
    style: {
      fill: "#275a93",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.4,357.28c0-7.21-.08-7.06-6.63-10.65-10.51-5.76-20.91-11.73-31.36-17.6,7.22-5.6,15.57-8.56,24.35-10.55.72-.16,1.51-.4,1.82.68,1.8,6.23,6.3,9.29,12.36,10.51v11.85c0,5.25,0,10.51,0,15.76l-.27.06-.27-.06h0Z",
    style: {
      fill: "#2a66a2",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65,372c-.11-1.32-1.1-1.85-2.1-2.41-8.91-5-17.8-10.03-26.7-15.04-.66-.37-1.36-.64-2.01-1.03-1.1-.66-1.62-.58-2.26.79-.98,2.11-1.12,4.55-2.65,6.42,1.63-7.33,4.9-13.89,9.44-19.83,1.43-.7,2.67-.24,3.95.49,10.4,5.88,20.79,11.8,31.27,17.54,1.83,1.01,1.62,1.83.71,3.14-3.82,2.74-6.8,6.28-9.65,9.95h0Z",
    style: {
      fill: "#285e98",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.14,439.9h.51v32.22c-1.11-3.07-.27-6.24-.5-9.36-.1-1.39-.02-2.8-.02-4.2-1.48-6.22-1.49-12.44,0-18.66h0Z",
    style: {
      fill: "#255188",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,387.88c4.02,1.12,7.25,3.79,10.89,5.66,4.74,2.44,9.29,5.27,13.93,7.91,6.76,3.83,13.5,7.71,20.32,11.43,1.38.75,1.78,1.56,1.75,3.04-.08,6.11-.03,12.22-.03,18.33-1.38,1.04-2.54.06-3.64-.51-6.02-3.11-11.88-6.54-17.73-9.94-4.31-2.51-8.87-4.59-13.02-7.39-.93-.63-1.45-.44-1.88.5-6.67-8.53-9.99-18.28-10.6-29.02h0Z",
    style: {
      fill: "#255188",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,416.91c-.08-.63-.16-1.26-.27-2.08,2.65.66,4.64,2.38,6.87,3.62,9.01,5,18,10.03,27,15.04.83.46,1.67.87,2.66.77v24.32c-4.06-.98-7.26-3.66-10.86-5.55-2.48-1.3-4.87-2.74-7.32-4.09-1.21-.67-2.18-.78-2.17,1.07,0,.65.07,1.33-.57,1.78.08-5.81.07-11.62.31-17.42.09-2.17-.25-3.52-2.32-4.78-5.3-3.25-9.85-7.44-13.34-12.66h0Z",
    style: {
      fill: "#244b82",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.93,489.75c-6.42.05-11.73-5.2-11.71-11.58.03-6.29,5.16-11.46,11.47-11.56,6.31-.1,11.73,5.28,11.72,11.61-.02,6.25-5.22,11.48-11.48,11.53h0Z",
    style: {
      fill: "#224176",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.38,304.26c6.85-.54,12.43,3.71,13.05,9.94.7,6.96-3.82,12.36-10.97,13.06-.9.09-1.88.28-2.72-.35.7-6.53.2-13.07.34-19.61.02-1.02-.19-2.06.29-3.04h0Z",
    style: {
      fill: "#6c9dcc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.38,304.26c.67,1.01.54,2.15.54,3.27,0,5.54.02,11.08,0,16.61,0,1.05.43,2.36-1.18,2.75-6.13-1.29-9.34-5.73-9.3-12.3.03-4.92,4.46-9.38,9.94-10.34Z",
    style: {
      fill: "#2c6ba8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.24,331.59c.43-1.34,1.27-2.25,2.7-2.52-.58,1.18-1.63,1.86-2.7,2.52Z",
    style: {
      fill: "#2a65a1",
      strokeWidth: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmmc);
export default __webpack_public_path__ + "static/media/CMMC.4a27797b1ca599a21f08dd35322b016e.svg";
export { ForwardRef as ReactComponent };